import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router";
import {
  TextField,
  Typography,
  Switch,
  Box,
  Grid,
  Backdrop,
  Card,
  Tooltip,
  CircularProgress,
  FormHelperText,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { getIn, useFormik } from "formik";
import moment from "moment";
import DeleteIcon from "@material-ui/icons/Delete";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { IAddGateEntery } from "src/common/typings/vehicle"; // Updated interface with new fields
import { showNotification } from "src/common/utils/app.util";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import CommonAutoCompleteField from "../../../../../../components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "../../../../../../components/CommonButton/CommonButton";
import CommonSelect from "../../../../../../components/molecules/CommonSelect";
import { Prompt } from "react-router-dom";
import {
  colorCodeListForGateIn,
  containerLoadTypeList,
  containerSIzeList,
  getContainerTypeList,
  customColorCodeList,
  containerQuantity,
} from "src/common/utils/app.dropdowns";
import { Autocomplete, SelectChangeEvent } from "@mui/material";
import InputMask from "react-input-mask";
import { useStyles } from "./styles";
import { getValidationSchema } from "./validations";
import {
  selectAllYardsListing,
  selectAllYardRowsListing,
  selectOnlyAvailableAllSlotsByRowId,
} from "src/app-redux/yard/yardSlice";
import {
  getAllRowsByYardIdAction,
  getAllAvailableSlotsByRowIdAction,
} from "src/app-redux/yard/actions/yardActions";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import MultiSelect2 from "src/components/molecules/MultiSelect2";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import CommonLoader from "src/components/Loader/CommonLoader";
import {
  selectAllPartyNameRowsList,
  selectAllTaxTypeRowsList,
} from "src/app-redux/configuration/configurationSlice";
import { getAllPartName } from "src/app-redux/configuration/actions/configurationActions";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";

export interface IForm extends IAddGateEntery {}

interface ContainerForGateOut {
  gateEntryId: number;
  containerNumber: string;
  createdDateTime: string;
  driverName: string;
  [key: string]: any;
}

interface Props {
  handleSubmit: (formData: IForm) => Promise<void>;
  updateSubmit: (formData: IForm) => Promise<void>;
  initialValues?: any;
  vehicleConfiguration?: any;
}

export function VehicleDriverDetailsInputs({
  initialValues,
  handleSubmit,
  updateSubmit,
  vehicleConfiguration,
}: Props): React.ReactElement {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = React.useState(false);

  const { id } = useParams<{ id: any }>();
  const updateCase = Boolean(id !== 0 && id !== null && id !== undefined);
  const terminalType = Number(localStorage.getItem("terminalType"));
  const [selectedCargoTypes, setSelectedCargoTypes] = useState<string[]>([]);
  const [consignmentType, setconsignmentType] = React.useState<any>([]);
  const [pendingContainerList, setPendingContainerList] = React.useState<any>([]);
  const [gdLoading, setGdLoading] = React.useState<boolean>(false);
  const [containerList, setContainerList] = React.useState<any>([]);
  const [vehiclesList, setVehcilesList] = React.useState<any>([]);
  const [loader, setLoader] = useState(false);
  const [loader2, setLoader2] = useState<any>(false);
  const [supplierTypeList, setSupplierTypeList] = useState([]);
  const [loadingSuppliers, setLoadingSuppliers] = useState(false);
  const [consigneeList, setConsigneeList] = useState<{ id: number; name: string }[]>([]);
  const [gdList, setGdList] = React.useState<any>([]);
  const [vehicleContainerNumbers, setVehicleContanerNumbers] = React.useState<any>([]);
  const [selectedContainersForGateOut, setSelectedContainersForGateOut] = React.useState<
    ContainerForGateOut[]
  >([]);

  const validationSchema = useMemo(() => getValidationSchema(terminalType), [terminalType]);

  const formik = useFormik<IAddGateEntery>({
    enableReinitialize: updateCase,
    initialValues: {
      dateTime: initialValues?.dateTime || moment(new Date()).format("YYYY-MM-DDTHH:mm"),
      entryDate: initialValues?.entryDate || moment(new Date()).format("YYYY-MM-DDTHH:mm"),
      vehicleRegNumber: initialValues?.vehicleRegNumber || "",
      billNo: initialValues?.billNo || "",
      indexNo: initialValues?.indexNo || "",
      vehicleTypeId: initialValues?.vehicleTypeId || "",
      consignmentTypeId: initialValues?.consignmentTypeId || "",
      consignmentTypeName:
        consignmentType.find((st: any) => st.id === initialValues?.consignmentTypeId)?.name || "",
      cargoTypeId: "21",
      slipNumber: initialValues?.slipNumber || "",
      driverName: initialValues?.driverName || "",
      destination: initialValues?.destination || "",
      voyage: initialValues?.voyage || "",
      vessel: initialValues?.vessel || "",
      travellingDocType: initialValues?.travellingDocType || "ID",
      travellingDocNumber: initialValues?.travellingDocNumber || "",
      carmNumber: initialValues?.carmNumber || "",
      carnetNumber: initialValues?.carnetNumber || "",
      crmNumber: initialValues?.crmNumber || "",
      eFormNumber: initialValues?.eFormNumber || "",
      locationInTerminal: initialValues?.locationInTerminal || "",
      vehicleStatusId: initialValues?.vehicleStatusId || "",
      gdDate: initialValues?.gdDate ? moment(initialValues.gdDate).format("YYYY-MM-DD") : "",
      driverFatherName: initialValues?.driverFatherName || "",
      commercial: initialValues?.commercial ? Boolean(initialValues.commercial) : true,
      driverResident: initialValues?.driverResident || "",
      gdNo: initialValues?.gdNo || "",
      virNo: initialValues?.virNo || "",
      virNumber: initialValues?.virNumber || "",
      webocVehicleNumber: initialValues?.webocVehicleNumber || "",
      remarks: initialValues?.remarks || "",
      vehicleChassisNumber: initialValues?.vehicleChassisNumber || "",
      notes: initialValues?.notes || "",
      vehicleColor: initialValues?.vehicleColor || "",
      vehicleBrand: initialValues?.vehicleBrand || "",
      vehicleModel: initialValues?.vehicleModel || "",
      vehicleMake: initialValues?.vehicleMake || "",
      driverMobileNumber: initialValues?.driverMobileNumber || "",
      agentMobileNumber: initialValues?.agentMobileNumber || "",
      driverCNIC: initialValues?.driverCNIC || "",
      exporterName: initialValues?.exporterName || "",
      exporterPhoneNumber: initialValues?.exporterPhoneNumber || "",
      importerName: initialValues?.importerName || "",
      importerPhoneNumber: initialValues?.importerPhoneNumber || "",
      driverNTN: initialValues?.driverNTN || "",
      supplierName: initialValues?.supplierName || "",
      webBocId: initialValues?.webBocId || "",
      agentName: initialValues?.agentName || "",
      vehicleColorCode: initialValues?.vehicleColorCode || 1,
      vehicleCustomColorCode: initialValues?.vehicleCustomColorCode || 1,
      yardId: initialValues?.yardId || "",
      yardRowId: initialValues?.rowId || "",
      yardSlotId: initialValues?.slotId || "",
      passNumber: initialValues?.passNumber || "",
      cargoTypeIds: "",
      isNodVehicle: true,
      isLoseCargo: false,
      //container details
      forwarder: initialValues?.forwarder || "",
      containerDetailsListField: initialValues?.containersDetail || [],
      containerListForGateOut: initialValues?.containerListForGateOut || [],
      // LCL-Empty specific fields
      virNumberLcl: initialValues?.virNumberLcl || "",
      paidIndexes: initialValues?.paidIndexes || "",
      // TP specific fields
      tpVirNumbers: initialValues?.tpVirNumbers || "",
      tpIndexes: initialValues?.tpIndexes || "",
      tpIndexVirPairs:
        (initialValues as any)?.tpIndexVirPairs ||
        (() => {
          const rawIndexes = String((initialValues as any)?.tpIndexes ?? "").trim();
          const rawVirs = String((initialValues as any)?.tpVirNumbers ?? "").trim();
          if (!rawIndexes && !rawVirs) return "";

          const splitList = (s: string) =>
            s
              .split(/[,\n;]+/g)
              .map((x) => x.trim())
              .filter(Boolean);

          const idxList = splitList(rawIndexes);
          const virList = splitList(rawVirs);

          if (idxList.length > 0 && idxList.length === virList.length) {
            return idxList.map((idx, i) => `${idx},${virList[i] ?? ""}`).join(";\n");
          }

          return `${rawIndexes}${rawIndexes && rawVirs ? "," : ""}${rawVirs}`;
        })(),
      tpContainerNumber: initialValues?.tpContainerNumber || "",
      containerQuantity: initialValues?.containerQuantity || "",
      containerSize: initialValues?.containerSize || "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      /** Backend binds `indexNo` as Int32; empty/hidden fields must not serialize as null. */
      const normalizeIndexNoInt = (v: any): number => {
        if (v === null || v === undefined || v === "") return 0;
        const n = parseInt(String(v).trim(), 10);
        return Number.isNaN(n) ? 0 : n;
      };
      const normalizeOptionalNumber = (v: any): number | null => {
        if (v === null || v === undefined || String(v).trim() === "") return null;
        const n = Number(String(v).trim());
        return Number.isFinite(n) ? n : null;
      };
      const normalizeCargoTypeStr = (v: any) =>
        String(v ?? "")
          .trim()
          .toUpperCase();

      const parseTpIndexVirPairs = (raw: any) => {
        const text = String(raw ?? "").trim();
        if (!text) return { tpIndexes: "", tpVirNumbers: "" };

        const entries = text
          .split(/[\n;]+/g)
          .map((x) => x.trim())
          .filter(Boolean);

        const indexes: string[] = [];
        const virNumbers: string[] = [];

        for (const entry of entries) {
          const [idxRaw, virRaw] = entry.split(",").map((x) => (x ?? "").trim());
          if (idxRaw) indexes.push(idxRaw);
          if (virRaw) virNumbers.push(virRaw);
        }

        return {
          tpIndexes: indexes.join(","),
          tpVirNumbers: virNumbers.join(","),
        };
      };

      /**
       * Terminal type 4 expects `dateTime` to be populated and `entryDate` to be null.
       * Some UI paths bind the picker to `entryDate`, so normalize here before mapping rows.
       */
      if (terminalType === 4) {
        const normalizedDateTime =
          (values as any)?.dateTime ??
          (values as any)?.entryDate ??
          moment().format("YYYY-MM-DDTHH:mm");
        (values as any).dateTime = normalizedDateTime;
        (values as any).entryDate = null;
      }

      // TP UI uses a single `Index,VIR` field; keep backend fields populated.
      if (values.consignmentTypeName === "TP") {
        // Ensure TP container number is sent in containerDetailsListField (backend expects container rows).
        const tpContainerNo = String((values as any)?.tpContainerNumber ?? "").trim();
        if (tpContainerNo) {
          const baseEntryDate =
            terminalType === 4
              ? null
              : (values as any)?.entryDate ?? (values as any)?.dateTime ?? null;

          if (!Array.isArray(values.containerDetailsListField)) {
            values.containerDetailsListField = [];
          }

          if (values.containerDetailsListField.length === 0) {
            values.containerDetailsListField = [
              {
                containerNumber: tpContainerNo,
                sealNo: "",
                cargoTypeIds: (values as any)?.cargoTypeIds ?? "",
                entryDate: baseEntryDate,
                containerIndexesList: [],
                noOfIndexes: null,
              } as any,
            ];
          } else {
            const first = values.containerDetailsListField[0] as any;
            if (!String(first?.containerNumber ?? "").trim()) first.containerNumber = tpContainerNo;
            if (first?.entryDate == null) first.entryDate = baseEntryDate;
            if (first?.cargoTypeIds == null || String(first.cargoTypeIds).trim() === "") {
              first.cargoTypeIds = (values as any)?.cargoTypeIds ?? "";
            }
            if (!Array.isArray(first?.containerIndexesList)) first.containerIndexesList = [];
            if (first?.noOfIndexes === undefined) first.noOfIndexes = null;
            if (first?.sealNo === undefined) first.sealNo = "";
          }

          // Don't send containerNumber at top-level for TP (send it in containerDetailsListField instead).
          delete (values as any).containerNumber;
        }

        const derived = parseTpIndexVirPairs((values as any)?.tpIndexVirPairs);
        if (!String((values as any)?.tpIndexes ?? "").trim()) {
          (values as any).tpIndexes = derived.tpIndexes;
        }
        if (!String((values as any)?.tpVirNumbers ?? "").trim())
          (values as any).tpVirNumbers = derived.tpVirNumbers;

        // Also send TP indexes in backend-required array shape.
        // Prefer the multi-select source (selectedTpIndexVir) when available.
        const fromSelected =
          Array.isArray(selectedTpIndexVir) && selectedTpIndexVir.length
            ? selectedTpIndexVir
                .map((x: any) => ({
                  indexNo: Number(x?.indexNo ?? 0),
                  virNo: String(x?.virNo ?? "").trim(),
                }))
                .filter((x: any) => x.indexNo && x.virNo)
            : null;

        const fromText = (() => {
          const pairsText = String((values as any)?.tpIndexVirPairs ?? "").trim();
          if (!pairsText) return [];
          const entries = pairsText
            .split(/[\n;]+/g)
            .map((x) => x.trim())
            .filter(Boolean);
          return entries
            .map((entry) => {
              const [idxRaw, virRaw] = entry.split(",").map((x) => (x ?? "").trim());
              return { indexNo: Number(idxRaw ?? 0), virNo: String(virRaw ?? "").trim() };
            })
            .filter((x) => x.indexNo && x.virNo);
        })();

        (values as any).virIndexes = (fromSelected ?? fromText) as any;

        // Do not send TP UI helper fields in payload.
        delete (values as any).tpIndexVirPairs;
        delete (values as any).tpIndexes;
        delete (values as any).tpVirNumbers;
        delete (values as any).tpContainerNumber;
      }

      const resolveContainerEntryDate = (row: any) => {
        if (terminalType === 4) return null;
        return row?.entryDate ?? (values as any)?.entryDate ?? (values as any)?.dateTime ?? null;
      };

      (values as any).indexNo = normalizeIndexNoInt((values as any).indexNo);
      if (Array.isArray(values.containerDetailsListField)) {
        values.containerDetailsListField = values.containerDetailsListField.map((row: any) => {
          const isLooseCargo = normalizeCargoTypeStr(row?.cargoType) === "LOOSE CARGO";
          const normalizedEntryDate = resolveContainerEntryDate(row);

          // Oracle proc `container_loose_cargo_index_create` is sensitive to types;
          // ensure we don't send ""/undefined for NUMBER params and avoid empty rows.
          const normalizedIndexes = Array.isArray(row?.containerIndexesList)
            ? row.containerIndexesList
                .map((idx: any) => ({
                  ...idx,
                  indexNo: normalizeIndexNoInt(idx?.indexNo),
                  importerId: normalizeOptionalNumber(idx?.importerId),
                  indexWeight: normalizeOptionalNumber(idx?.indexWeight),
                }))
                .filter((idx: any) => idx.indexNo && idx.indexNo > 0)
            : row?.containerIndexesList;

          return {
            ...row,
            entryDate: normalizedEntryDate,
            noOfIndexes: isLooseCargo ? row?.noOfIndexes : row?.noOfIndexes ?? null,
            containerIndexesList: isLooseCargo
              ? normalizedIndexes
              : row?.containerIndexesList ?? [],
          };
        });
      }

      // Strip consigneeId from container details so only consignee (id as string) is sent
      const stripConsigneeId = (items: any[]) =>
        Array.isArray(items) ? items.map(({ consigneeId, ...rest }) => rest) : items ?? [];

      // Map container details to containerListForGateOut for submission
      if (values.consignmentTypeName === "Empty-Export") {
        // For Empty-Export, send the selected container detail objects
        values.containerListForGateOut = stripConsigneeId(selectedContainersForGateOut || []).map(
          (row: any) => ({
            ...row,
            entryDate: resolveContainerEntryDate(row),
          })
        );
      } else if (values.consignmentTypeName === "Import") {
        // For Import, keep containerDetailsListField with data but set containerListForGateOut as empty array
        values.containerListForGateOut = [];
      } else {
        // For other consignment types, keep existing container details mapping
        values.containerListForGateOut = stripConsigneeId(
          values.containerDetailsListField || []
        ).map((row: any) => ({
          ...row,
          entryDate: resolveContainerEntryDate(row),
        }));
      }
      const shouldForwarderBeInContainerDetails =
        terminalType !== 4 && values.consignmentTypeName === "Import";
      values.containerDetailsListField = stripConsigneeId(
        values.containerDetailsListField || []
      ).map((row: any) => ({
        ...row,
        forwarder: shouldForwarderBeInContainerDetails
          ? String(row?.forwarder ?? "")
          : row?.forwarder,
        entryDate: resolveContainerEntryDate(row),
      }));
      if (values.vehicleMake == "" || values.vehicleMake == null) values.vehicleMake = null;

      if (id !== 0 && id !== null && id !== undefined) {
        values.gatePassId = id;
        updateSubmit({
          ...values,
          vehicleRegNumber: values.vehicleRegNumber.toUpperCase(),
          indexes: values.paidIndexes,
        });
      } else {
        handleSubmit({
          ...values,
          vehicleRegNumber: values.vehicleRegNumber.toUpperCase(),
          indexes: values.paidIndexes,
        });
      }
      actions.setSubmitting(false);
      setIsDirty(false);
      values.vehicleMake = "";
    },
  });
  const { height } = UseWindowDimensions(); // get browser dimension
  const minAccHeight = 50; // Right Content
  let accordionMaxHeight = 0;
  accordionMaxHeight = height - minAccHeight;
  const [submitCounter, setSubmitCounter] = useState<any>(0);
  const [vehiclestatusList, setvehicleStatusList] = React.useState<any>([]);
  const [locationAtTerminal, setlocationAtTerminal] = React.useState<any>([]);
  const [vehicleType, setvehicleType] = React.useState<any>([]);
  const [typeOfCargoArray, settypeOfCargoArray] = React.useState<any>([]);
  const [vehicleNumberLength, setVehicleNumberLength] = useState<number>(0);
  const [virNumber, setvirNumber] = React.useState<any[]>([]);
  const [isDirty, setIsDirty] = React.useState<boolean>(false);
  const [paidIndexesList, setPaidIndexesList] = React.useState<any[]>([]);

  const normalizeCargoTypeStr = (v: any) => (v ?? "").toString().trim().toUpperCase();

  const isLooseCargoContainerType = useMemo(() => {
    const list = (formik.values as any)?.containerDetailsListField ?? [];
    if (!Array.isArray(list)) return false;
    return list.some((item: any) => normalizeCargoTypeStr(item?.cargoType) === "LOOSE CARGO");
  }, [(formik.values as any)?.containerDetailsListField]);

  const isLooseCargoRow = (idx: number) =>
    normalizeCargoTypeStr((formik.values.containerDetailsListField ?? [])[idx]?.cargoType) ===
    "LOOSE CARGO";

  const handleNoOfIndexesChange = (containerIndex: number, rawValue: string) => {
    const parsed = parseInt(rawValue, 10);
    const n = rawValue === "" || Number.isNaN(parsed) ? 0 : Math.max(0, Math.min(50, parsed));
    const existing =
      (formik.values.containerDetailsListField ?? [])[containerIndex]?.containerIndexesList ?? [];
    const nextRows = Array.from({ length: n }, (_, i) => ({
      indexNo: existing[i]?.indexNo ?? "",
      importerId: existing[i]?.importerId ?? "",
      indexWeight: existing[i]?.indexWeight ?? "",
    }));
    formik.setFieldValue(
      `containerDetailsListField.${containerIndex}.noOfIndexes`,
      rawValue === "" ? "" : String(n)
    );
    formik.setFieldValue(
      `containerDetailsListField.${containerIndex}.containerIndexesList`,
      nextRows
    );
    setIsDirty(true);
  };
  const [selectedPaidIndexes, setSelectedPaidIndexes] = React.useState<any[]>([]);
  const [tpConsignmentRows, setTpConsignmentRows] = React.useState<any[]>([]);
  const [tpContainerOptions, setTpContainerOptions] = React.useState<any[]>([]);
  const [selectedTpIndexVir, setSelectedTpIndexVir] = React.useState<any[]>([]);
  const allcontainerQuantity = useMemo(() => {
    const size = String((formik.values as any)?.containerSize ?? "").trim();
    return size === "20" ? containerQuantity : ["1"];
  }, [(formik.values as any)?.containerSize]);
  const multiselectRef: any = useRef();

  const syncContainerDetailsToQuantity = (quantity: number, containerSize: string) => {
    if (Number.isNaN(quantity) || quantity <= 0) return;

    const currentDetails = (formik.values as any)?.containerDetailsListField || [];
    const entryDate = (formik.values as any).entryDate || formik.values.dateTime || "";

    let updatedDetails = (Array.isArray(currentDetails) ? currentDetails : []).map(
      (detail: any) => ({
        ...detail,
        containerSize: containerSize || detail?.containerSize || "",
      })
    );

    if (quantity > updatedDetails.length) {
      const toAdd = quantity - updatedDetails.length;
      const blanks = Array.from({ length: toAdd }).map(() => ({
        containerNumber: "",
        sealNo: "",
        cargoTypeIds: "",
        noOfDays: "",
        containerSize: containerSize,
        entryDate: entryDate,
      }));
      updatedDetails = [...updatedDetails, ...blanks];
    } else if (quantity < updatedDetails.length) {
      updatedDetails = updatedDetails.slice(0, quantity);
    }

    formik.setFieldValue("containerDetailsListField", updatedDetails);
    setContainerList(updatedDetails);
  };

  useEffect(() => {
    const current = String((formik.values as any)?.containerQuantity ?? "").trim();
    if (!current) return;
    if (!allcontainerQuantity.includes(current)) {
      const nextQty = allcontainerQuantity[0] ?? "";
      formik.setFieldValue("containerQuantity", nextQty);

      // Keep terminal type 4 container detail rows in sync with the forced quantity.
      if (
        terminalType === 4 &&
        ((formik.values as any)?.consignmentTypeName === "Import" ||
          (formik.values as any)?.consignmentTypeName === "Export") &&
        nextQty
      ) {
        const quantity = Number(nextQty);
        const containerSize = String((formik.values as any)?.containerSize ?? "").trim();
        if (!Number.isNaN(quantity) && quantity > 0 && containerSize) {
          syncContainerDetailsToQuantity(quantity, containerSize);
        }
      }
    }
    // Intentionally depend on the computed options and current value.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allcontainerQuantity, (formik.values as any)?.containerQuantity, terminalType]);

  useEffect(() => {
    if (vehicleConfiguration.vehicleStatusData?.length > 0) {
      setvehicleStatusList(vehicleConfiguration.vehicleStatusData);
      id ??
        formik.setFieldValue(
          "vehicleStatusId",
          vehicleConfiguration.vehicleStatusData.find(
            (st: any) =>
              st.name === "In-progress" ||
              st.name === "In-Progress" ||
              st.name === "Inprogress" ||
              st.name === "InProgress"
          )?.id
        );
    }
    if (vehicleConfiguration.terminalLocationData?.length > 0) {
      setlocationAtTerminal(vehicleConfiguration.terminalLocationData);
      id ??
        formik.setFieldValue(
          "locationInTerminal",
          vehicleConfiguration.terminalLocationData.find((st: any) => st.name === "Gate-entry")?.id
        );
    }
    if (vehicleConfiguration.vehicleTypeData?.length > 0) {
      setvehicleType(vehicleConfiguration.vehicleTypeData);
      if (terminalType !== 4 && !id) {
        const tenWheeler = vehicleConfiguration.vehicleTypeData.find(
          (st: any) => st.name === "10 Wheeler"
        );
        if (tenWheeler) {
          formik.setFieldValue("vehicleTypeId", tenWheeler.id);
        }
        formik.setFieldValue("travellingDocType", "ID");
      }
    }

    const incomingConsignments = (vehicleConfiguration as any)?.consignmentTypeData ?? [];
    const normalizedConsignments = Array.isArray(incomingConsignments)
      ? incomingConsignments.map((c: any) => ({
          id: c?.id ?? c?.value ?? c?.consignmentTypeId ?? c?.consignmentTypeID,
          name: c?.name ?? c?.label ?? c?.consignmentTypeName ?? "",
        }))
      : [];
    setconsignmentType(normalizedConsignments.filter((c: any) => c?.id && c?.name));

    if (vehicleConfiguration.cargoTypeData?.length > 0)
      settypeOfCargoArray(vehicleConfiguration.cargoTypeData);
  }, [vehicleConfiguration]);

  useEffect(() => {
    const arr: any[] = [];
    if (
      formik.values.consignmentTypeName == "Loose Cargo" ||
      formik.values.consignmentTypeName === "LCL-Empty"
    ) {
      initialValues?.cargoTypeIds.forEach((item: any) => {
        const type = typeOfCargoArray.find((cargo: any) => cargo.id === item);
        if (type) arr.push(type);
      });
      setSelectedCargoTypes(arr);
    }
  }, [initialValues]);
  useEffect(() => {
    const multiItem = typeOfCargoArray.find((cargo: any) => cargo.name === "Multi items");
    const emptyType = typeOfCargoArray.find((cargo: any) => cargo.name === "Empty");
    if (
      formik.values.consignmentTypeName === "Import" &&
      multiItem &&
      (formik.values.containerDetailsListField ?? []).length > 0
    ) {
      const updatedContainers = (formik.values.containerDetailsListField ?? []).map(
        (container: any) => {
          // Only set if empty
          if (!container.cargoTypeIds || container.cargoTypeIds === "") {
            return {
              ...container,
              cargoTypeIds: multiItem.id.toString(),
            };
          }
          return container;
        }
      );

      // Only update if at least one was changed
      if (
        JSON.stringify(formik.values.containerDetailsListField) !==
        JSON.stringify(updatedContainers)
      ) {
        formik.setFieldValue("containerDetailsListField", updatedContainers);
      }

      // Also set top-level cargoTypeIds (optional)
      if (!formik.values.cargoTypeIds || formik.values.cargoTypeIds === "") {
        formik.setFieldValue("cargoTypeIds", multiItem.id.toString());
      }
    }
    if (
      formik.values.consignmentTypeName === "LCL-Empty" &&
      emptyType &&
      (formik.values.containerDetailsListField ?? []).length > 0
    ) {
      const updatedContainers = (formik.values.containerDetailsListField ?? []).map(
        (container: any) => {
          // Only set if empty
          if (!container.cargoTypeIds || container.cargoTypeIds === "") {
            return {
              ...container,
              cargoTypeIds: emptyType.id.toString(),
            };
          }
          return container;
        }
      );

      // Only update if at least one was changed
      if (
        JSON.stringify(formik.values.containerDetailsListField) !==
        JSON.stringify(updatedContainers)
      ) {
        formik.setFieldValue("containerDetailsListField", updatedContainers);
      }

      // Also set top-level cargoTypeIds (optional)
      if (!formik.values.cargoTypeIds || formik.values.cargoTypeIds === "") {
        formik.setFieldValue("cargoTypeIds", emptyType.id.toString());
      }
    }
    if (formik.values.consignmentTypeName === "LCL-Empty" && emptyType) {
      formik.setFieldValue("cargoTypeIds", emptyType.id.toString());
    }
    // Handle Empty-Export separately to ensure cargoTypeIds is set
    if (formik.values.consignmentTypeName === "Empty-Export" && emptyType) {
      formik.setFieldValue("cargoTypeIds", emptyType.id.toString());
    }
  }, [
    formik.values.consignmentTypeName,
    formik.values.containerDetailsListField,
    typeOfCargoArray,
  ]);

  const getCargoTypes = (index: number) => {
    const arr: any[] = [];
    if (
      formik.values.containerDetailsListField &&
      typeof formik.values.containerDetailsListField[index]?.cargoTypeIds == "string"
    ) {
      formik.values.containerDetailsListField &&
        formik.values.containerDetailsListField[index]?.cargoTypeIds &&
        formik.values?.containerDetailsListField[index]?.cargoTypeIds
          ?.split(",")
          .forEach((item: any) => {
            const type = typeOfCargoArray.find((cargo: any) => cargo.id === Number(item));
            if (type) arr.push(type);
          });
    } else {
      formik.values.containerDetailsListField &&
        formik.values.containerDetailsListField[index]?.cargoTypeIds &&
        formik.values?.containerDetailsListField[index]?.cargoTypeIds
          ?.split(",")
          ?.forEach((item: any) => {
            const type = typeOfCargoArray.find((cargo: any) => cargo.id === Number(item));
            if (type) arr.push(type);
          });
    }
    return arr;
  };

  const onMultiSelectSelection = (selectedList: any) => {
    const cargoTypes: string = selectedList.map((item: any) => (item.id ? item.id : "")).toString();
    formik.setFieldValue("cargoTypeIds", cargoTypes);
  };
  const onMultiSelectRemove = (selectedList: any) => {
    const cargoTypes: string = selectedList.map((item: any) => (item.id ? item.id : "")).toString();
    formik.setFieldValue("cargoTypeIds", cargoTypes);
  };

  const onPaidIndexesSelect = (selectedList: any) => {
    const paidIndexes: string = selectedList
      .map((item: any) => (item.indexNumber ? item.indexNumber : ""))
      .toString();
    formik.setFieldValue("paidIndexes", paidIndexes);
    setSelectedPaidIndexes(selectedList);
  };

  const onPaidIndexesRemove = (selectedList: any) => {
    const paidIndexes: string = selectedList
      .map((item: any) => (item.indexNumber ? item.indexNumber : ""))
      .toString();
    formik.setFieldValue("paidIndexes", paidIndexes);
    setSelectedPaidIndexes(selectedList);
  };

  useEffect(() => {
    if (formik.isValid === false) {
      showNotification("Please fill complete form.", "error", dispatch);
    }
    if (submitCounter) {
      formik.submitForm();
    }
  }, [submitCounter]);

  // Slots Record
  const allYardsList: any = useAppSelector(selectAllYardsListing);
  const allRowsList: any = useAppSelector(selectAllYardRowsListing);
  const allAvailableSlotsList: any = useAppSelector(selectOnlyAvailableAllSlotsByRowId);
  const [allYards, setAllYards] = React.useState<any[]>([]);
  const [allRows, setAllRows] = React.useState<any[]>([]);
  const [allAvailableSlots, setAllAvailableSlots] = React.useState<any[]>([]);

  useEffect(() => {
    const option1 = [{ id: 0, name: "Select Yard Name" }];
    setAllYards(option1.concat(allYardsList));
  }, [allYardsList]);

  ////////// For terminal Type = 4
  useEffect(() => {
    if (terminalType === 4 && containerList.length === 0) {
      const emptyContainer = {
        containerNumber: "",
        sealNumber: "",
        virNo: "",
        cargoTypeIds: "", // assuming this is also part of your form
      };
      setContainerList([emptyContainer]);
    }
  }, [terminalType]);
  useEffect(() => {
    const option1 = [{ id: 0, rowName: "Select Yard Row Number" }];
    setAllRows(option1.concat(allRowsList));
  }, [allRowsList]);
  useEffect(() => {
    const option1 = [{ id: 0, columnOrder: "Select Yard Row Slot" }];
    setAllAvailableSlots(option1.concat(allAvailableSlotsList));
  }, [allAvailableSlotsList]);
  useEffect(() => {
    if (id !== 0 && id !== null && id !== undefined) {
      if (
        initialValues?.yardId !== 0 &&
        initialValues?.yardId !== null &&
        initialValues?.yardId !== undefined
      )
        dispatch(getAllRowsByYardIdAction(initialValues?.yardId)); // get all Rows by Yard Id
      if (
        initialValues?.rowId !== 0 &&
        initialValues?.rowId !== null &&
        initialValues?.rowId !== undefined
      )
        dispatch(getAllAvailableSlotsByRowIdAction(initialValues?.rowId));
    }
  }, [initialValues]);
  const getVehicleGDs = async () => {
    const results = await fetchWrapper.post("get-all-pending-gds", {});
    if (results.isSuccess) {
      setGdList(results.value.getAllPendingGds);
    }
    return;
  };

  const getTpVehicleConsignment = async () => {
    setLoading(true);
    try {
      const results = await fetchWrapper.get("gate-entry-tp-vehicle-consignment");
      if (!results?.isSuccess) return;

      const payload = results.value;
      const rows: any[] = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.value)
        ? payload.value
        : Array.isArray(payload?.list)
        ? payload.list
        : [];

      setTpConsignmentRows(rows);

      const uniqueContainers = Array.from(
        new Set(
          rows
            .map((r: any) => String(r?.containerNo ?? r?.containerNumber ?? "").trim())
            .filter(Boolean)
        )
      ).map((c) => ({ containerNo: c }));
      setTpContainerOptions(uniqueContainers);

      const splitList = (s: string) =>
        String(s ?? "")
          .split(/[,\n;]+/g)
          .map((x) => x.trim())
          .filter(Boolean);

      const toPairs = (idxRaw: any, virRaw: any) => {
        const idxList = splitList(idxRaw);
        const virList = splitList(virRaw);
        if (idxList.length > 0 && idxList.length === virList.length) {
          return idxList.map((idx, i) => `${idx},${virList[i] ?? ""}`).join(";");
        }
        const a = String(idxRaw ?? "").trim();
        const b = String(virRaw ?? "").trim();
        return `${a}${a && b ? "," : ""}${b}`;
      };

      // Common shapes: { tpIndexes, tpVirNumbers } or { indexes, virNumbers }
      const tpIndexes =
        payload?.tpIndexes ?? payload?.indexes ?? payload?.tpIndex ?? payload?.indexNumbers ?? "";
      const tpVirNumbers =
        payload?.tpVirNumbers ?? payload?.virNumbers ?? payload?.tpVir ?? payload?.virNos ?? "";

      if (String(tpIndexes).trim() || String(tpVirNumbers).trim()) {
        const pairs = toPairs(tpIndexes, tpVirNumbers);
        formik.setFieldValue("tpIndexes", String(tpIndexes ?? ""));
        formik.setFieldValue("tpVirNumbers", String(tpVirNumbers ?? ""));
        formik.setFieldValue("tpIndexVirPairs", pairs);
        setIsDirty(true);
        return;
      }

      if (rows.length) {
        const indexes: string[] = [];
        const virs: string[] = [];
        const pairs: string[] = [];
        rows.forEach((item: any) => {
          const idx = item?.indexNo ?? item?.index ?? item?.tpIndex ?? item?.indexNumber ?? "";
          const vir = item?.virNo ?? item?.virNumber ?? item?.tpVir ?? "";
          if (String(idx).trim()) indexes.push(String(idx).trim());
          if (String(vir).trim()) virs.push(String(vir).trim());
          if (String(idx).trim() || String(vir).trim()) pairs.push(`${idx},${vir}`);
        });

        formik.setFieldValue("tpIndexes", indexes.join(","));
        formik.setFieldValue("tpVirNumbers", virs.join(","));
        formik.setFieldValue("tpIndexVirPairs", pairs.join(";"));
        setIsDirty(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const getWebocVehicleNumber = async (gd: any) => {
    setGdLoading(true);
    try {
      const results = await fetchWrapper.post("get-all-details-by-gd", { gdNo: gd });

      if (results.isSuccess) {
        const containerDetails = results.value?.getAllVehicleNumbers ?? results.value ?? [];
        const normalizedContainerDetails = Array.isArray(containerDetails)
          ? containerDetails
          : [containerDetails];

        setContainerList(normalizedContainerDetails);
        formik.setFieldValue("containerDetailsListField", normalizedContainerDetails);
      } else {
        setContainerList([]);
        formik.setFieldValue("containerDetailsListField", []);
      }
    } finally {
      setGdLoading(false);
    }
  };
  useEffect(() => {
    window.onbeforeunload = function (e: Event) {
      if (isDirty) {
        e.preventDefault();
        return "Changes you made may not be saved.";
      }
    };
  }, [isDirty]);
  function handleValueChange(e: any) {
    formik.handleChange(e);
    e.target.value || JSON.stringify(formik.values) !== JSON.stringify(formik.initialValues)
      ? setIsDirty(true)
      : setIsDirty(false);
  }

  const debounce = (func: (...args: any[]) => void, delay: number) => {
    let timeoutId: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  const [isSubmitting, setIsSubmitting] = useState(false);

  const debounceSubmit = debounce(() => {
    setIsSubmitting(true);
    formik.submitForm().finally(() => {
      setIsSubmitting(false);
    });
  }, 1000);

  const listener = (e: any) => {
    if (
      (e.key === "s" || e.key === "S") &&
      (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
    ) {
      e.preventDefault();
      if (JSON.stringify(formik.initialValues) != JSON.stringify(formik.values)) {
        debounceSubmit();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [formik.values, isSubmitting]);
  const allPartyNameRows = useAppSelector(selectAllPartyNameRowsList);
  const scrollContainerRef: any = useRef(null);
  const datePickerRef: any = useRef(null);
  const gddatePickerRef: any = useRef(null);
  useEffect(() => {
    dispatch(getAllPartName(true));
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      // Hide the calendar when the container is scrolled
      datePickerRef?.current?.flatpickr?.close();
      gddatePickerRef?.current?.flatpickr?.close();
    };
    scrollContainerRef?.current?.addEventListener("scroll", handleScroll);
    return () => {
      scrollContainerRef?.current?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const getAllPendingContainer = async (consignmentType: any) => {
    setLoading(true);
    setPendingContainerList([]);
    try {
      const results = await fetchWrapper.post("get-all-pending-containers", {
        consignmentType,
      });
      if (results.isSuccess) {
        setPendingContainerList(results.value.list);
      }
      setLoading(false);
      return;
    } catch (error) {
      setLoading(false);
    }
  };

  const getVehicleContainerNumbers = async () => {
    setLoader(true);
    const results = await fetchWrapper.get("get-all-vehicles-and-containers-for-gate-out");
    setLoader(false);

    if (results.isSuccess) {
      setVehicleContanerNumbers(results.value);
    }
    return;
  };

  const getAllVirGd = async (id: any) => {
    setLoading(true);
    setContainerList([]);
    try {
      const results = await fetchWrapper.post("get-all-containsers-by-gd-or-vir", {
        id,
        consignmentType: formik.values.consignmentTypeName,
        virNo: formik.values.virNo ? formik.values.virNo : formik.values.gdNo,
        isEdit: updateCase,
      });
      if (results.isSuccess) {
        setContainerList(results.value.containersList);
        const filterContainer = results.value.containersList;
        filterContainer.map((data: any, index: number) => {
          formik.setFieldValue("vehicleRegNumber", data?.vehicleNumber || "");
          formik.setFieldValue("billNo", data?.billNo || "");
          formik.setFieldValue("indexNo", data?.indexNo || "");

          formik.setFieldValue(
            `containerDetailsListField.${index}.containerNumber`,
            data.containerNumber
          );
          formik.setFieldValue(`containerDetailsListField.${index}.sealNo`, data.sealNumber);
          const containerGrossWeight = data?.containerGrossWeight || "";
          formik.setFieldValue(
            `containerDetailsListField.${index}.containerGrossWeight`,
            containerGrossWeight
          );
          // Set vessel and other container detail fields
          formik.setFieldValue(`containerDetailsListField.${index}.vessel`, data?.vessel || "");
          formik.setFieldValue(
            `containerDetailsListField.${index}.consignee`,
            data?.consignee || ""
          );
          formik.setFieldValue(
            `containerDetailsListField.${index}.transporter`,
            data?.transporter || ""
          );
          formik.setFieldValue(`containerDetailsListField.${index}.voyage`, data?.voyage || "");
          formik.setFieldValue(
            `containerDetailsListField.${index}.containerSize`,
            data?.containerSize || ""
          );
          formik.setFieldValue(
            `containerDetailsListField.${index}.containerLoadType`,
            data?.containerLoadType || ""
          );
          formik.setFieldValue(
            `containerDetailsListField.${index}.cargoType`,
            data?.cargoType || ""
          );
          formik.setFieldValue(
            `containerDetailsListField.${index}.cargoTypeId`,
            data?.cargoTypeId || ""
          );
        });
      }
      setLoading(false);
      return;
    } catch (error) {
      setLoading(false);
    }
  };
  const getContainerListing = async (vir: string | number) => {
    setLoader(true);
    try {
      const results = await fetchWrapper.get(`get-vir-vehicles/${id}?isEdit=${updateCase}`);
      if (results.isSuccess == true) {
        setContainerList(results.value?.continers);
      }
      setLoader(false);
      return;
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };
  const getvirNumber = async (virNo: string) => {
    let results: any = [];
    results = await fetchWrapper.get(`search-vir-number/${virNo}`);
    if (results.isSuccess) {
      setvirNumber(results.value.virList);
    }
    return;
  };

  const getPaidIndexes = async (virNo: string) => {
    try {
      const results = await fetchWrapper.get(`get-vir-paid-indexes/${virNo}`);
      if (results.isSuccess) {
        setPaidIndexesList(results.value.indexes || []);
      } else {
        setPaidIndexesList([]);
      }
    } catch (error) {
      console.error("Error fetching paid indexes:", error);
      setPaidIndexesList([]);
    }
  };
  const getListing = async () => {
    let results: any = [];
    try {
      results = await fetchWrapper.get(`get_all-supplier-details?getActiveSuppliersOnly=${true}`);
      if (results.isSuccess == true) {
        setSupplierTypeList(results.value);
      }
      return;
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };
  useEffect(() => {
    const fetchSuppliers = async () => {
      setLoadingSuppliers(true);
      await getListing(); // This sets supplierTypeList
      setLoadingSuppliers(false);
    };

    fetchSuppliers();
  }, []);

  const getConsigneeListing = async () => {
    try {
      const results = await fetchWrapper.get(`get_all-consignee-details?isActive=${true}`);
      if (results.isSuccess === true) {
        const raw = results.value?.consigneeList ?? results.value;
        const list = Array.isArray(raw)
          ? raw.map((item: { id: number; name?: string }) => ({
              id: item.id,
              name: item.name ?? "",
            }))
          : [];
        setConsigneeList(list);
      }
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };

  useEffect(() => {
    getConsigneeListing();
  }, []);

  const getAllVehicles = async (id: any) => {
    setVehcilesList([]);
    try {
      const results = await fetchWrapper.get(`get-vir-vehicles/${id}?isEdit=${updateCase}`);
      if (results.isSuccess) {
        setVehcilesList(results.value?.vehicleResponse);
      }
      setLoading(false);
      return;
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (terminalType !== 4) {
      if (initialValues?.consignmentTypeName) {
        // getAllPendingContainer(initialValues?.consignmentTypeName);
        getAllVirGd(initialValues?.vehicleRegNumber);
        getAllVehicles(initialValues?.virNo);
      }
      if (initialValues?.vehicleRegNumber) {
        getAllVirGd(initialValues?.vehicleRegNumber);
        getAllVehicles(initialValues?.virNo);
      }
      if (initialValues?.gdNo) {
        getAllVirGd(initialValues?.gdNo);
      }
    }
  }, [initialValues]);

  // Call getVehicleContainerNumbers when Empty-Export is selected
  useEffect(() => {
    if (formik.values.consignmentTypeName === "Empty-Export") {
      getVehicleContainerNumbers();
    }
  }, [formik.values.consignmentTypeName]);

  const isDisabled = (parms: any) => {
    // For Export, vehicle number should NOT be disabled
    if (parms === "Export" || parms === "export") return false;

    // For Import (and other types you want locked), keep existing behavior
    if (parms === "Import" || parms === "import") return true;

    return false;
  };
  const [filteredNominations, setFilteredNominations] = useState<any[]>([]);

  // Add this function to handle container deletion
  const handleDeleteContainer = (index: number) => {
    // Remove from containerList
    setContainerList((prev: any[]) => prev.filter((_: any, i: number) => i !== index));
    // Remove from formik values
    const updatedDetails = (formik.values.containerDetailsListField || []).filter(
      (_: any, i: number) => i !== index
    );
    formik.setFieldValue("containerDetailsListField", updatedDetails);
  };

  return (
    <>
      {/* If prompt, when navigating to another page inside the app */}
      <Prompt when={isDirty} message={"Changes you made may not be saved."} />

      <form onSubmit={formik.handleSubmit}>
        <Backdrop className={classes.backdrop} open={loading}>
          <CommonLoader />
        </Backdrop>
        <Grid container direction="row" alignItems="flex-start">
          {/* First Section */}
          <>
            <Grid
              item
              md={12}
              component={Card}
              className={classes.tabCardContent}
              style={{ height: accordionMaxHeight }}
              ref={scrollContainerRef}
            >
              <Grid className={classes.UserMainPanel}>
                <Grid className={classes.formRow}>
                  <Grid item xs={12}>
                    <Box textAlign="right" mb={2} mt={1}>
                      <CommonButton
                        cssClass="customSubmitBtn"
                        onClick={() => {
                          formik.resetForm();
                          if (updateCase) {
                            formik.setValues({
                              ...formik.initialValues,
                            });
                          }
                        }}
                      >
                        Reset
                      </CommonButton>
                      <CommonButton
                        isGreen
                        cssClass="customSubmitBtn"
                        disable={
                          id &&
                          JSON.stringify(formik.initialValues) == JSON.stringify(formik.values)
                        }
                        onClick={() => {
                          setSubmitCounter((prev: any) => prev + 1);
                        }}
                      >
                        {initialValues?.gateEntryId ? "Update" : "Save"}
                      </CommonButton>
                    </Box>
                  </Grid>
                </Grid>
                <Grid container direction="row" alignItems="center" spacing={2}>
                  {/* Gate-entry Details Section */}
                  <Grid
                    item
                    md={12}
                    className={`${classes.sectionHeading} ${classes.sectionHeadingFirstSec}`}
                  >
                    <Typography>Gate-Entry Details:</Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box>
                      <CommonAutoCompleteField
                        cssClassName="customTextField"
                        error={
                          formik.touched.consignmentTypeId &&
                          Boolean(formik.errors.consignmentTypeId)
                        }
                        helperText={
                          formik.touched.consignmentTypeId && formik.errors.consignmentTypeId
                        }
                        label="Type of Consignment"
                        placeholder="Select Type Of Consignment"
                        name="consignmentTypeId"
                        optionsType={consignmentType}
                        required
                        disabled={initialValues?.gateEntryId}
                        getOptionLabel={(option: any) => option.name || ""}
                        value={
                          consignmentType.find(
                            (st: any) => st.id === formik.values.consignmentTypeId
                          ) || null
                        }
                        onChange={async (option: any) => {
                          if (option && option.id !== 0) {
                            formik.setFieldValue("billNo", "");
                            formik.setFieldValue("vehicleRegNumber", "");
                            formik.setFieldValue("gdNo", "");
                            formik.setFieldValue("virNo", "");
                            formik.setFieldValue("tpVirNumbers", "");
                            formik.setFieldValue("tpIndexes", "");
                            formik.setFieldValue("tpIndexVirPairs", "");
                            formik.setFieldValue("tpContainerNumber", "");
                            setTpConsignmentRows([]);
                            setTpContainerOptions([]);
                            setSelectedTpIndexVir([]);

                            formik.setFieldValue("consignmentTypeId", option.id);
                            formik.setFieldValue("consignmentTypeName", option.name);
                            formik.setFieldValue("containerDetailsListField", []);
                            setContainerList([]);
                            handleValueChange({ target: { value: option.id } });
                            if (option.name === "Export") {
                              getVehicleGDs();
                            }
                            if (
                              String(option?.name ?? "")
                                .trim()
                                .toUpperCase() === "TP"
                            ) {
                              await getTpVehicleConsignment();
                            }
                            if (option.name == "Import" || option.name == "Export") {
                              formik.setFieldValue("isLoseCargo", false);
                              // getAllPendingContainer(option.name);
                            } else {
                              formik.setFieldValue("isLoseCargo", true);
                            }
                          }
                        }}
                      />
                    </Box>
                  </Grid>
                  {(terminalType === 4 ||
                    (terminalType !== 4 && formik.values.consignmentTypeName !== "Import")) && (
                    <Grid item xs={12} md={4}>
                      <CommonTextFieldDate
                        cssClassName={`${classes.dateTime} ${"customTextField"}`}
                        outerCss={true}
                        datePickerRef={datePickerRef}
                        label={"Entry Date and Time"}
                        name={"dateTime"}
                        required={true}
                        value={formik.values.dateTime}
                        onChange={(e: any) => {
                          formik.setFieldValue("dateTime", e);
                          // Terminal type 4 historically also used `entryDate` in some flows.
                          // Keep it in sync so submit normalization never "snaps back" to the initial value.
                          if (terminalType === 4) {
                            formik.setFieldValue("entryDate", e);
                          }
                        }}
                        maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                        isReadOnly={updateCase}
                        error={formik.touched.dateTime && Boolean(formik.errors.dateTime)}
                        helperText={formik.touched.dateTime && formik.errors.dateTime}
                      />
                    </Grid>
                  )}
                  {formik.values.consignmentTypeName === "TP" && (
                    <>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <CommonAutoCompleteField
                            cssClassName="customTextField"
                            label="TP Container Number"
                            placeholder="Select TP Container Number"
                            name="tpContainerNumber"
                            optionsType={tpContainerOptions}
                            getOptionLabel={(option: any) => option?.containerNo || ""}
                            value={
                              tpContainerOptions.find(
                                (o: any) =>
                                  String(o?.containerNo ?? "").trim() ===
                                  String((formik.values as any)?.tpContainerNumber ?? "").trim()
                              ) || null
                            }
                            onChange={(option: any) => {
                              const containerNo = String(option?.containerNo ?? "").trim();
                              formik.setFieldValue("tpContainerNumber", containerNo);

                              // Reset dependent fields
                              setSelectedTpIndexVir([]);
                              formik.setFieldValue("tpIndexVirPairs", "");
                              formik.setFieldValue("tpIndexes", "");
                              formik.setFieldValue("tpVirNumbers", "");

                              const rows = (tpConsignmentRows ?? []).filter(
                                (r: any) =>
                                  String(r?.containerNo ?? r?.containerNumber ?? "").trim() ===
                                  containerNo
                              );

                              // VehicleNo in API should populate Vehicle Number
                              const vehicleNo = String(rows?.[0]?.vehicleNo ?? "").trim();
                              if (vehicleNo) {
                                formik.setFieldValue("vehicleRegNumber", vehicleNo);
                              }

                              setIsDirty(true);
                            }}
                          />
                        </Box>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={4}
                        style={{
                          top: "15px",
                          position: "relative",
                          padding: "0 8px",
                        }}
                      >
                        <Box>
                          <TextField
                            required
                            className={"customTextField"}
                            size="small"
                            fullWidth
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            onKeyDown={(event: any) => {
                              if (event.key !== "Tab") event.preventDefault();
                            }}
                            label={'Index + VIR (format: "Index,VIR")'}
                            error={
                              formik.touched.tpIndexVirPairs &&
                              Boolean((formik.errors as any)?.tpIndexVirPairs)
                            }
                            helperText={
                              formik.touched.tpIndexVirPairs &&
                              (formik.errors as any)?.tpIndexVirPairs
                            }
                          />
                          <Box
                            className={classes.multiselectConfigFileCompression}
                            style={{
                              bottom:
                                formik.touched.tpIndexVirPairs &&
                                Boolean((formik.errors as any)?.tpIndexVirPairs)
                                  ? "55px"
                                  : "35px",
                            }}
                          >
                            <MultiSelect2
                              allValues={(tpConsignmentRows ?? [])
                                .filter(
                                  (r: any) =>
                                    String(r?.containerNo ?? r?.containerNumber ?? "").trim() ===
                                    String((formik.values as any)?.tpContainerNumber ?? "").trim()
                                )
                                .map((r: any) => ({
                                  indexNo: r?.indexNo,
                                  virNo: r?.virNo,
                                  label: `${r?.indexNo},${r?.virNo}`,
                                }))}
                              selctedItems={selectedTpIndexVir}
                              displayValue={"label"}
                              placeholder='Select "Index,VIR"'
                              onSelect={(selectedList: any) => {
                                setSelectedTpIndexVir(selectedList);
                                const indexes = (selectedList ?? [])
                                  .map((x: any) => x?.indexNo)
                                  .filter((x: any) => x !== undefined && x !== null && x !== "");
                                const virNos = (selectedList ?? [])
                                  .map((x: any) => x?.virNo)
                                  .filter((x: any) => x !== undefined && x !== null && x !== "");
                                const pairs = (selectedList ?? [])
                                  .map((x: any) => x?.label)
                                  .filter(Boolean);

                                formik.setFieldValue("tpIndexes", indexes.join(","));
                                formik.setFieldValue("tpVirNumbers", virNos.join(","));
                                formik.setFieldValue("tpIndexVirPairs", pairs.join(";"));
                                setIsDirty(true);
                              }}
                              onRemove={(selectedList: any) => {
                                setSelectedTpIndexVir(selectedList);
                                const indexes = (selectedList ?? [])
                                  .map((x: any) => x?.indexNo)
                                  .filter((x: any) => x !== undefined && x !== null && x !== "");
                                const virNos = (selectedList ?? [])
                                  .map((x: any) => x?.virNo)
                                  .filter((x: any) => x !== undefined && x !== null && x !== "");
                                const pairs = (selectedList ?? [])
                                  .map((x: any) => x?.label)
                                  .filter(Boolean);

                                formik.setFieldValue("tpIndexes", indexes.join(","));
                                formik.setFieldValue("tpVirNumbers", virNos.join(","));
                                formik.setFieldValue("tpIndexVirPairs", pairs.join(";"));
                                setIsDirty(true);
                              }}
                            />
                          </Box>
                        </Box>
                      </Grid>
                    </>
                  )}
                  {/* VIR Number field for LCL-Empty */}
                  {formik.values.consignmentTypeName === "LCL-Empty" && (
                    <Grid
                      item
                      xs={12}
                      md={4}
                      style={{
                        position: "relative",
                        padding: "0 8px",
                      }}
                    >
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="VIR Number"
                          placeholder="Select VIR Number"
                          name="virNumberLcl"
                          optionsType={virNumber} // This should be your list of VIRs
                          getOptionLabel={(option) => option.virNo || ""}
                          required
                          value={
                            virNumber.find((st: any) => st.virNo === formik.values.virNumberLcl) ||
                            null
                          }
                          onChange={(option: any) => {
                            formik.setFieldValue("virNumberLcl", option?.virNo || "");
                            if (option?.virNo) {
                              getPaidIndexes(option.virNo); // Call your existing method
                            } else {
                              setPaidIndexesList([]);
                              setSelectedPaidIndexes([]);
                            }
                          }}
                          onKeyUp={(e: any) => {
                            setVehicleNumberLength(e.target.value.length);

                            if (e.target.value.length === 2 && vehicleNumberLength < 2) {
                              getvirNumber(e.target.value); // This fetches VIR suggestions
                              return;
                            }
                          }}
                          onKeyDownCapture={(e: any) => {
                            if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
                            else formik.handleChange(e);
                          }}
                          onPaste={(e: any) => {
                            const pasted = e.clipboardData.getData("text");
                            if (/[^A-Za-z0-9\d]/.test(pasted)) {
                              e.preventDefault();
                              return;
                            }

                            if (pasted.length >= 2) getvirNumber(pasted);
                          }}
                          error={formik.touched.virNumberLcl && Boolean(formik.errors.virNumberLcl)}
                          helperText={formik.touched.virNumberLcl && formik.errors.virNumberLcl}
                        />
                      </Box>
                    </Grid>
                  )}

                  {/* Paid Indexes field for LCL-Empty */}
                  {formik.values.consignmentTypeName === "LCL-Empty" && (
                    <Grid
                      item
                      xs={12}
                      md={4}
                      style={{
                        top: "15px",
                        position: "relative",
                        padding: "0 8px",
                      }}
                    >
                      <Box>
                        <TextField
                          required={true}
                          className={"customTextField"}
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onKeyDown={(event: any) => {
                            if (event.key !== "Tab") event.preventDefault();
                          }}
                          label="Paid Indexes"
                          error={formik.touched.paidIndexes && Boolean(formik.errors.paidIndexes)}
                          helperText={formik.touched.paidIndexes && formik.errors.paidIndexes}
                        />
                        <Box
                          className={classes.multiselectConfigFileCompression}
                          style={{
                            bottom:
                              formik.touched.paidIndexes && Boolean(formik.errors.paidIndexes)
                                ? "55px"
                                : "35px",
                          }}
                        >
                          <MultiSelect2
                            allValues={paidIndexesList}
                            selctedItems={selectedPaidIndexes}
                            displayValue={"indexNumber"}
                            placeholder="Select Paid Indexes"
                            onSelect={onPaidIndexesSelect}
                            onRemove={onPaidIndexesRemove}
                            ref={multiselectRef}
                          />
                        </Box>
                      </Box>
                    </Grid>
                  )}
                  {formik.values.consignmentTypeName == "Export" && (
                    <>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <CommonAutoCompleteField
                            cssClassName="customTextField"
                            error={formik.touched.gdNo && Boolean(formik.errors.gdNo)}
                            helperText={formik.touched.gdNo && formik.errors.gdNo}
                            label="Good’s Declaration Number (GD#)"
                            name="gdNo"
                            optionsType={gdList}
                            placeholder="Select GD#"
                            required={formik.values.consignmentTypeName == "Export"}
                            getOptionLabel={(option: any) => option.gdNo || ""}
                            value={gdList.find((st: any) => st.gdNo == formik.values.gdNo) || null}
                            onChange={(option: any) => {
                              const selectedGd = option?.gdNo || "";
                              formik.setFieldValue("gdNo", selectedGd);
                              handleValueChange({ target: { value: selectedGd } });
                              if (selectedGd) {
                                // Only load WEBoc vehicle numbers here.
                                // Containers will be loaded when a vehicle is selected.
                                getWebocVehicleNumber(selectedGd);
                              }
                            }}
                          />
                        </Box>
                      </Grid>
                    </>
                  )}
                  {terminalType !== 4 && formik.values.consignmentTypeName !== "Import" && (
                    <Grid item xs={12} md={4}>
                      <Box>
                        <TextField
                          className="customTextField"
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          error={
                            formik.touched.vehicleRegNumber &&
                            Boolean(formik.errors.vehicleRegNumber)
                          }
                          helperText={
                            formik.touched.vehicleRegNumber && formik.errors.vehicleRegNumber
                          }
                          label="Vehicle Number"
                          name="vehicleRegNumber"
                          placeholder="Enter Vehicle Number"
                          required
                          value={formik.values.vehicleRegNumber}
                          onChange={(e) => {
                            const value = e.target.value.toUpperCase().replace(/\s+/g, ""); // removes all spaces

                            formik.setFieldValue("vehicleRegNumber", value);
                          }}
                          disabled={isDisabled(formik.values.consignmentTypeName) || updateCase}
                        />
                      </Box>
                    </Grid>
                  )}

                  {formik.values.consignmentTypeName === "Empty-Export" && (
                    <Grid
                      item
                      xs={12}
                      md={containerList.length > 1 && terminalType === 4 ? 3 : 4}
                      style={{
                        top: "15px",
                        position: "relative",
                        padding: "0 8px",
                      }}
                    >
                      <Box>
                        {/* Fake TextField for Label Display (no input) */}
                        <TextField
                          className="customTextField"
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputProps={{
                            readOnly: true,
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label={"Select Containers for Gate Out"}
                          value={selectedContainersForGateOut.length > 0 ? " " : ""}
                          // This allows the label to float without actual value
                        />

                        {/* Multiselect field below fake TextField */}
                        <Box
                          className={classes.multiselectConfigFileCompression}
                          style={{
                            bottom:
                              formik.touched.containerListForGateOut &&
                              Boolean(formik.errors.containerListForGateOut)
                                ? "55px"
                                : "35px",
                          }}
                        >
                          <MultiSelect2
                            allValues={vehicleContainerNumbers?.containerList || []}
                            selctedItems={selectedContainersForGateOut}
                            displayValue={"containerNumber"}
                            placeholder="Select Containers for Gate Out"
                            onSelect={(selectedList: ContainerForGateOut[]) => {
                              setSelectedContainersForGateOut(selectedList);
                              formik.setFieldValue("containerListForGateOut", selectedList);

                              // For Empty-Export, send empty array in containerDetailsListField
                              if (formik.values.consignmentTypeName === "Empty-Export") {
                                formik.setFieldValue("containerDetailsListField", []);
                              }

                              setContainerList(selectedList);
                            }}
                            onRemove={(selectedList: ContainerForGateOut[]) => {
                              setSelectedContainersForGateOut(selectedList);
                              formik.setFieldValue("containerListForGateOut", selectedList);

                              // For Empty-Export, send empty array in containerDetailsListField
                              if (formik.values.consignmentTypeName === "Empty-Export") {
                                formik.setFieldValue("containerDetailsListField", []);
                              }

                              setContainerList(selectedList);
                            }}
                          />
                        </Box>

                        {/* Validation Error */}
                        {formik.touched.containerListForGateOut &&
                          formik.errors.containerListForGateOut && (
                            <FormHelperText error style={{ marginLeft: "14px" }}>
                              {formik.errors.containerListForGateOut}
                            </FormHelperText>
                          )}
                      </Box>
                    </Grid>
                  )}

                  {formik.values.consignmentTypeName === "Empty-Export" &&
                    selectedContainersForGateOut.length > 0 && (
                      <Grid item xs={12} md={4}>
                        <Box>
                          <TextField
                            className="customTextField"
                            size="small"
                            fullWidth
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="VIR Number(s)"
                            name="virNumbers"
                            placeholder="VIR Number(s)"
                            disabled={true}
                            value={selectedContainersForGateOut
                              .map((c) => c.virNo)
                              .filter((v) => v)
                              .join(", ")}
                          />
                        </Box>
                      </Grid>
                    )}

                  {formik.values.consignmentTypeName === "Import" && (
                    <>
                      {terminalType === 4 ? (
                        // ✅ Manual Text Fields (when terminalType === 4)
                        <>
                          <Grid item xs={12} md={4}>
                            <Box>
                              <TextField
                                className="customTextField"
                                fullWidth
                                size="small"
                                variant="outlined"
                                label="IGM Number"
                                name="virNo"
                                placeholder="Enter IGM Number"
                                InputLabelProps={{ shrink: true }}
                                value={formik.values.virNo}
                                onChange={formik.handleChange}
                                required
                                error={formik.touched.virNo && Boolean(formik.errors.virNo)}
                                helperText={formik.touched.virNo && formik.errors.virNo}
                                disabled={initialValues?.gateEntryId}
                              />
                            </Box>
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <Box>
                              <TextField
                                className="customTextField"
                                fullWidth
                                size="small"
                                variant="outlined"
                                label="Vehicle Number"
                                name="vehicleRegNumber"
                                placeholder="Enter Vehicle Number"
                                InputLabelProps={{ shrink: true }}
                                value={formik.values.vehicleRegNumber}
                                onChange={(e) => {
                                  const value = e.target.value.toUpperCase().replace(/\s+/g, ""); // removes all spaces

                                  formik.setFieldValue("vehicleRegNumber", value);
                                }}
                                required={formik.values.consignmentTypeName === "Import"}
                                error={
                                  formik.touched.vehicleRegNumber &&
                                  Boolean(formik.errors.vehicleRegNumber)
                                }
                                helperText={
                                  formik.touched.vehicleRegNumber && formik.errors.vehicleRegNumber
                                }
                                disabled={initialValues?.gateEntryId}
                              />
                            </Box>
                          </Grid>
                        </>
                      ) : (
                        // 🔽 Dropdown Fields (for other terminal types)
                        <>
                          <Grid item xs={12} md={4}>
                            {/* <Box>
                              <CommonAutoCompleteField
                                cssClassName="customTextField"
                                error={formik.touched.virNo && Boolean(formik.errors.virNo)}
                                helperText={formik.touched.virNo && formik.errors.virNo}
                                label="VIR Number"
                                name="virNo"
                                optionsType={pendingContainerList}
                                placeholder="Select VIR#"
                                required
                                getOptionLabel={(option: any) => option.id || ""}
                                value={
                                  pendingContainerList.find(
                                    (st: any) => st.id === formik.values.virNo
                                  ) || null
                                }
                                onChange={(option: any) => {
                                  formik.setFieldValue("virNo", option.id);
                                  handleValueChange({ target: { value: option.id } });
                                  getAllVehicles(option.id);
                                  setContainerList([]);
                                }}
                                disabled={initialValues?.gateEntryId}
                              />
                            </Box> */}
                            <Box>
                              <CommonAutoCompleteField
                                cssClassName="customTextField"
                                label="VIR Number"
                                placeholder="Select VIR Number"
                                name="virNumber"
                                optionsType={virNumber}
                                getOptionLabel={(option) => option.virNo || ""}
                                required
                                value={
                                  virNumber.find((st: any) => st.virNo === formik.values.virNo) ||
                                  null
                                }
                                onChange={(option: any) => {
                                  formik.setFieldValue("virNo", option.virNo);
                                  formik.setFieldValue("containerNumber", "");
                                  formik.setFieldValue("gatePassId", "");
                                  formik.setFieldValue("vehicleNumber", "");
                                  getAllVehicles(option?.virNo);
                                }}
                                onKeyUp={(e: any) => {
                                  setVehicleNumberLength(e.target.value.length);

                                  if (e.target.value.length == 2 && vehicleNumberLength < 2) {
                                    getvirNumber(e.target.value);
                                    return;
                                  }
                                }}
                                onKeyDownCapture={(e: any) => {
                                  if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
                                  else formik.handleChange(e);
                                }}
                                onPaste={(e: any) => {
                                  if (/[^A-Za-z0-9\d]/.test(e.clipboardData.getData("text"))) {
                                    e.preventDefault();
                                    return;
                                  }

                                  if (e.clipboardData.getData("text").length >= 2)
                                    getvirNumber(e.clipboardData.getData("text"));
                                }}
                                error={
                                  formik.touched.registrationNumber &&
                                  Boolean(formik.errors.registrationNumber)
                                }
                                helperText={
                                  formik.touched.registrationNumber &&
                                  formik.errors.registrationNumber
                                }
                              />
                            </Box>
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <Box>
                              <CommonAutoCompleteField
                                cssClassName="customTextField"
                                error={
                                  formik.touched.vehicleRegNumber &&
                                  Boolean(formik.errors.vehicleRegNumber)
                                }
                                helperText={
                                  formik.touched.vehicleRegNumber && formik.errors.vehicleRegNumber
                                }
                                label="Vehicle Number"
                                name="vehicleRegNumber"
                                optionsType={vehiclesList}
                                placeholder="Select Vehicle Number"
                                required
                                getOptionLabel={(option: any) => option?.vehicleNumber || ""}
                                value={
                                  vehiclesList.find(
                                    (st: any) => st.vehicleNumber === formik.values.vehicleRegNumber
                                  ) || null
                                }
                                onChange={(option: any) => {
                                  formik.setFieldValue("vehicleRegNumber", option.id);
                                  handleValueChange({ target: { value: option.id } });
                                  if (terminalType !== 4) getAllVirGd(option.vehicleNumber);
                                }}
                                disabled={initialValues?.gateEntryId}
                              />
                            </Box>
                          </Grid>
                        </>
                      )}
                    </>
                  )}

                  {/* Vehicle Number and Vehicle Type for terminalType === 4 and consignmentType other than Import/Export */}
                  {terminalType === 4 &&
                    formik.values.consignmentTypeName !== "Import" &&
                    formik.values.consignmentTypeName !== "Export" && (
                      <>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              className="customTextField"
                              fullWidth
                              size="small"
                              variant="outlined"
                              label="Vehicle Number"
                              name="vehicleRegNumber"
                              placeholder="Enter Vehicle Number"
                              InputLabelProps={{ shrink: true }}
                              value={formik.values.vehicleRegNumber}
                              onChange={(e) => {
                                const value = e.target.value.toUpperCase().replace(/\s+/g, ""); // removes all spaces

                                formik.setFieldValue("vehicleRegNumber", value);
                              }}
                              required
                              error={
                                formik.touched.vehicleRegNumber &&
                                Boolean(formik.errors.vehicleRegNumber)
                              }
                              helperText={
                                formik.touched.vehicleRegNumber && formik.errors.vehicleRegNumber
                              }
                              disabled={initialValues?.gateEntryId}
                            />
                          </Box>
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <Box>
                            <CommonAutoCompleteField
                              cssClassName="customTextField"
                              error={
                                formik.touched.vehicleTypeId && Boolean(formik.errors.vehicleTypeId)
                              }
                              helperText={
                                formik.touched.vehicleTypeId && formik.errors.vehicleTypeId
                              }
                              label="Vehicle Type"
                              name="vehicleTypeId"
                              optionsType={vehicleType}
                              placeholder="Select Vehicle Type"
                              required
                              getOptionLabel={(option: any) => option.name || ""}
                              value={
                                vehicleType.find(
                                  (st: any) => st.id === formik.values.vehicleTypeId
                                ) || null
                              }
                              onChange={(option: any) => {
                                if (option && option.id !== 0) {
                                  formik.setFieldValue("vehicleTypeId", option.id);
                                  handleValueChange({ target: { value: option.id } });
                                }
                              }}
                            />
                          </Box>
                        </Grid>
                      </>
                    )}

                  {/* Vehicle Type for terminalType === 4 with Import/Export */}
                  {terminalType === 4 &&
                    (formik.values.consignmentTypeName === "Import" ||
                      formik.values.consignmentTypeName === "Export") && (
                      <Grid item xs={12} md={4}>
                        <Box>
                          <CommonAutoCompleteField
                            cssClassName="customTextField"
                            error={
                              formik.touched.vehicleTypeId && Boolean(formik.errors.vehicleTypeId)
                            }
                            helperText={formik.touched.vehicleTypeId && formik.errors.vehicleTypeId}
                            label="Vehicle Type"
                            name="vehicleTypeId"
                            optionsType={vehicleType}
                            placeholder="Select Vehicle Type"
                            required
                            getOptionLabel={(option: any) => option.name || ""}
                            value={
                              vehicleType.find(
                                (st: any) => st.id === formik.values.vehicleTypeId
                              ) || null
                            }
                            onChange={(option: any) => {
                              if (option && option.id !== 0) {
                                formik.setFieldValue("vehicleTypeId", option.id);
                                handleValueChange({ target: { value: option.id } });
                              }
                            }}
                          />
                        </Box>
                      </Grid>
                    )}
                  {(formik.values.consignmentTypeName == "Export" ||
                    formik.values.consignmentTypeName == "Import") &&
                    containerList &&
                    containerList?.map((data: any, index: number) => (
                      <>
                        {/* <Grid
                          item
                          xs={12}
                          md={containerList.length > 1 && terminalType === 4 ? 3 : 4}
                        >
                          <Box>
                            <TextField
                              className="customTextField"
                              type="text"
                              size="small"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label={`Container Number ${index + 1}`}
                              name={`containerDetailsListField.${index}.containerNumber`}
                              placeholder="Enter Container Number"
                              disabled={
                                terminalType !== 4 ||
                                formik.values.consignmentTypeName === "Empty-Export"
                              }
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]
                                      ?.containerNumber ||
                                    data?.containerNumber ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              // value={data?.containerNumber || ""}
                            />
                          </Box>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={containerList.length > 1 && terminalType === 4 ? 3 : 4}
                        >
                          <Box>
                            <TextField
                              className="customTextField"
                              type="text"
                              size="small"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label={`Container Seal Number ${index + 1}`}
                              name={`containerDetailsListField.${index}.sealNo`}
                              placeholder="Enter Container Seal Number"
                              disabled={
                                terminalType !== 4 ||
                                formik.values.consignmentTypeName === "Empty-Export"
                              }
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.sealNo ||
                                    data?.sealNo ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              // value={data?.sealNumber || ""}
                            />
                          </Box>
                        </Grid> */}
                        {/* <Grid
                          item
                          xs={12}
                          md={containerList.length > 1 && terminalType === 4 ? 3 : 4}
                        >
                          <Box>
                            <TextField
                              className="customTextField"
                              type="text"
                              size="small"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label={`Container Gross Weight ${index + 1}`}
                              name={`containerDetailsListField.${index}.containerGrossWeight`}
                              placeholder="Enter Container Gross Weight"
                              disabled={terminalType !== 4}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]
                                      ?.containerGrossWeight ||
                                    data?.containerGrossWeight ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                            />
                          </Box>
                        </Grid> */}
                        {updateCase && terminalType !== 4 && (
                          <Grid item xs={12} md={4}>
                            <Box>
                              <TextField
                                required={
                                  formik.values.consignmentTypeName === "Export" ||
                                  formik.values.consignmentTypeName === "Import"
                                }
                                className="customTextField"
                                type="text"
                                size="small"
                                fullWidth
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                label={`NLC Seal Number ${index + 1}`}
                                name={`containerDetailsListField.${index}.NlcSealNo`}
                                placeholder="Enter NLC Seal Number"
                                value={
                                  formik.values.containerDetailsListField?.[index]?.NlcSealNo || ""
                                }
                                onChange={handleValueChange}
                              />
                            </Box>
                          </Grid>
                        )}
                        {terminalType !== 4 && formik.values.consignmentTypeName !== "Import" && (
                          <Grid
                            item
                            xs={12}
                            md={containerList.length > 1 && terminalType === 4 ? 3 : 4}
                            style={{
                              top: "15px",
                              position: "relative",
                              padding: "0 8px",
                            }}
                          >
                            <Box>
                              <TextField
                                required={true}
                                className={"customTextField"}
                                size="small"
                                fullWidth
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                onKeyDown={(event: any) => {
                                  if (event.key !== "Tab") event.preventDefault();
                                }}
                                label={`Type of Cargo ${index + 1}`}
                                id={`containerDetailsListField.${index}.cargoTypeIds`}
                                name={`containerDetailsListField.${index}.cargoTypeIds`}
                                error={
                                  getIn(
                                    formik.touched,
                                    `containerDetailsListField.${index}.cargoTypeIds`
                                  ) &&
                                  Boolean(
                                    getIn(
                                      formik.errors,
                                      `containerDetailsListField.${index}.cargoTypeIds`
                                    )
                                  )
                                }
                                helperText={
                                  getIn(
                                    formik.touched,
                                    `containerDetailsListField.${index}.cargoTypeIds`
                                  ) &&
                                  getIn(
                                    formik.errors,
                                    `containerDetailsListField.${index}.cargoTypeIds`
                                  )
                                }
                              />
                              <Box
                                className={classes.multiselectConfigFileCompression}
                                style={{
                                  bottom:
                                    getIn(
                                      formik.touched,
                                      `containerDetailsListField.${index}.cargoTypeIds`
                                    ) &&
                                    Boolean(
                                      getIn(
                                        formik.errors,
                                        `containerDetailsListField.${index}.cargoTypeIds`
                                      )
                                    )
                                      ? "55px"
                                      : "35px",
                                }}
                              >
                                <MultiSelect2
                                  allValues={typeOfCargoArray}
                                  selctedItems={getCargoTypes(index)}
                                  displayValue={"name"}
                                  placeholder="Select Type of Cargo"
                                  onSelect={(selectedList: any) => {
                                    const cargoTypes: string = selectedList
                                      .map((item: any) => (item.id ? item.id : ""))
                                      .toString();
                                    formik.setFieldValue(
                                      `containerDetailsListField[${index}].cargoTypeIds`,
                                      cargoTypes
                                    );
                                  }}
                                  onRemove={(selectedList: any) => {
                                    const cargoTypes: string = selectedList
                                      .map((item: any) => (item.id ? item.id : ""))
                                      .toString();
                                    formik.setFieldValue(
                                      `containerDetailsListField[${index}].cargoTypeIds`,
                                      cargoTypes
                                    );
                                  }}
                                  ref={multiselectRef}
                                />
                              </Box>
                            </Box>
                          </Grid>
                        )}
                      </>
                    ))}
                  {/* {terminalType === 4 && formik.values.consignmentTypeName === "Import" && (
                    <Grid item xs={12} md={12}>
                      <Box>
                        <CommonButton
                          isGreen
                          cssClass="customSubmitBtn"
                          disable={
                            id &&
                            JSON.stringify(formik.initialValues) == JSON.stringify(formik.values)
                          }
                          onClick={() => {
                            const newContainer = {
                              containerNumber: "",
                              sealNo: "",
                              cargoTypeIds: "",
                            };
                            setContainerList((prev: any[]) => [...prev, newContainer]);
                            formik.setFieldValue("containerDetailsListField", [
                              ...(formik.values.containerDetailsListField || []),
                              newContainer,
                            ]);
                          }}
                        >
                          {"Add another container"}
                        </CommonButton>
                      </Box>
                    </Grid>
                  )} */}
                  {formik.values.consignmentTypeName != "Import" || terminalType === 4 ? (
                    <>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <TextField
                            required={formik.values.consignmentTypeName === "Import TIR"}
                            size="small"
                            fullWidth
                            className="customTextField"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label={
                              formik.values.consignmentTypeName === "Import TIR"
                                ? "Bill Number/VIR Number"
                                : "Bill Number"
                            }
                            name="billNo"
                            id="billNo"
                            placeholder={
                              formik.values.consignmentTypeName === "Import TIR"
                                ? "Enter Bill Number/VIR Number"
                                : "Enter Bill Number"
                            }
                            // disabled={true}
                            value={formik.values.billNo}
                            onChange={handleValueChange}
                            // onPaste={(e: any) => {
                            //   if (/[^A-Za-z0-9 ]/.test(e.clipboardData.getData("text")))
                            //     e.preventDefault();
                            // }}
                            // onKeyDownCapture={(e: any) => {
                            //   if (/[^A-Za-z0-9 ]/.test(e.key)) e.preventDefault();
                            // }}
                            error={formik.touched.billNo && Boolean(formik.errors.billNo)}
                            helperText={formik.touched.billNo && formik.errors.billNo}
                          />
                        </Box>
                      </Grid>
                      {terminalType === 4 && !isLooseCargoContainerType && (
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Index Number"
                              name="indexNo"
                              id="indexNo"
                              placeholder="Enter Index Number"
                              value={formik.values.indexNo}
                              onChange={handleValueChange}
                              error={formik.touched.indexNo && Boolean(formik.errors.indexNo)}
                              helperText={formik.touched.indexNo && (formik.errors as any).indexNo}
                            />
                          </Box>
                        </Grid>
                      )}
                      {/* commented vehicle number */}
                      {/* {terminalType !== 4 && (
                        <Grid item xs={12} md={4}>
                          <Box>
                            <CommonAutoCompleteField
                              cssClassName="customTextField"
                              error={
                                formik.touched.vehicleRegNumber &&
                                Boolean(formik.errors.vehicleRegNumber)
                              }
                              helperText={
                                formik.touched.vehicleRegNumber && formik.errors.vehicleRegNumber
                              }
                              label="Vehicle Number"
                              name="vehicleRegNumber"
                              optionsType={
                                (formik.values.consignmentTypeName as string) === "Export"
                                  ? weBocVehicleID
                                  : vehiclesList
                              }
                              placeholder="Select Vehicle Number"
                              required
                              getOptionLabel={(option: any) => option?.vehicleNumber || ""}
                              value={
                                ((formik.values.consignmentTypeName as string) === "Export"
                                  ? weBocVehicleID
                                  : vehiclesList
                                ).find(
                                  (st: any) => st.vehicleNumber === formik.values.vehicleRegNumber
                                ) || null
                              }
                              onChange={(option: any) => {
                                const selectedVehicleNumber = option?.vehicleNumber || "";
                                formik.setFieldValue("vehicleRegNumber", selectedVehicleNumber);
                                handleValueChange({ target: { value: selectedVehicleNumber } });
                                if (terminalType !== 4 && selectedVehicleNumber) {
                                  // After selecting a vehicle number, load containers by GD/Vehicle
                                  getAllVirGd(selectedVehicleNumber);
                                }
                              }}
                              disabled={isDisabled(formik.values.consignmentTypeName) || updateCase}
                            />
                          </Box>
                        </Grid>
                      )} */}
                    </>
                  ) : null}
                  {["Loose Cargo", "TP", "Import TIR"].includes(
                    formik.values.consignmentTypeName ?? ""
                  ) && (
                    <>
                      <Grid
                        item
                        xs={12}
                        md={4}
                        style={{
                          top: "15px",
                          position: "relative",
                          padding: "0 8px",
                        }}
                      >
                        <Box>
                          <TextField
                            required={["Loose Cargo", "TP", "Import TIR"].includes(
                              String(formik.values.consignmentTypeName ?? "")
                            )}
                            className={"customTextField"}
                            size="small"
                            fullWidth
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onKeyDown={(event: any) => {
                              if (event.key !== "Tab") event.preventDefault();
                            }}
                            label="Type of Cargo"
                            error={
                              formik.touched.cargoTypeIds && Boolean(formik.errors.cargoTypeIds)
                            }
                            helperText={formik.touched.cargoTypeIds && formik.errors.cargoTypeIds}
                          />
                          <Box
                            className={classes.multiselectConfigFileCompression}
                            style={{
                              bottom:
                                formik.touched.cargoTypeIds && Boolean(formik.errors.cargoTypeIds)
                                  ? "55px"
                                  : "35px",
                            }}
                          >
                            <MultiSelect2
                              allValues={typeOfCargoArray}
                              selctedItems={selectedCargoTypes}
                              displayValue={"name"}
                              placeholder="Select Type of Cargo"
                              onSelect={onMultiSelectSelection}
                              onRemove={onMultiSelectRemove}
                              ref={multiselectRef}
                            />
                          </Box>
                        </Box>
                      </Grid>
                    </>
                  )}
                  {/* Forwarder: for terminalType !== 4 + Import it belongs in Container Details */}
                  {!(terminalType !== 4 && formik.values.consignmentTypeName === "Import") && (
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Forwarder"
                          placeholder="Select Forwarder Name"
                          name="forwarder"
                          optionsType={allPartyNameRows}
                          getOptionLabel={(option) => option.name || ""}
                          value={
                            allPartyNameRows.find(
                              (st: any) => String(st.id) === String(formik.values.forwarder)
                            ) || null
                          }
                          onChange={(option: any) => {
                            const forwarderId = String(option?.id ?? "");
                            formik.setFieldValue("forwarder", forwarderId);
                            handleValueChange({ target: { value: forwarderId } });
                          }}
                          error={formik.touched.forwarder && Boolean(formik.errors.forwarder)}
                          helperText={formik.touched.forwarder && formik.errors.forwarder}
                        />
                      </Box>
                    </Grid>
                  )}
                  {terminalType === 4 && (
                    <Grid item xs={12} md={4}>
                      <Box>
                        <TextField
                          className="customTextField"
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="TP Number"
                          name="slipNumber"
                          id="slipNumber"
                          placeholder="Enter TP Number"
                          value={formik.values.slipNumber}
                          onChange={handleValueChange}
                          error={formik.touched.slipNumber && Boolean(formik.errors.slipNumber)}
                          helperText={formik.touched.slipNumber && formik.errors.slipNumber}
                        />
                      </Box>
                    </Grid>
                  )}
                  {terminalType === 4 && (
                    <>
                      {/* <Grid item xs={12} md={4}>
                        <CommonTextFieldDate
                          cssClassName={`${classes.dateTime} ${"customTextField"}`}
                          outerCss={true}
                          datePickerRef={datePickerRef}
                          label={"Entry Date and Time"}
                          name={"entryDate"}
                          required={true}
                          value={(formik.values as any).entryDate}
                          onChange={(e: any) => {
                            formik.setFieldValue("entryDate", e);

                            const currentDetails = formik.values.containerDetailsListField || [];
                            const updatedDetails = currentDetails.map((detail: any) => ({
                              ...detail,
                              entryDate: e,
                            }));
                            formik.setFieldValue("containerDetailsListField", updatedDetails);
                          }}
                          maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                          isReadOnly={false}
                          error={
                            (formik.touched as any).entryDate &&
                            Boolean((formik.errors as any).entryDate)
                          }
                          helperText={
                            (formik.touched as any).entryDate && (formik.errors as any).entryDate
                          }
                        />
                      </Grid> */}
                      <Grid item xs={12} md={4}>
                        <Box>
                          <CommonAutoCompleteField
                            cssClassName="customTextField"
                            label="Container Size (Feet)"
                            placeholder="Select Container Size"
                            name="containerSize"
                            optionsType={containerSIzeList}
                            required={
                              terminalType === 4 &&
                              (formik.values.consignmentTypeName === "Import" ||
                                formik.values.consignmentTypeName === "Export")
                            }
                            getOptionLabel={(option: any) => option || ""}
                            value={
                              containerSIzeList.find(
                                (st: any) => st == formik.values.containerSize
                              ) || null
                            }
                            onChange={(option: any) => {
                              if (option && option !== "") {
                                formik.setFieldValue("containerSize", option);
                                handleValueChange({ target: { value: option } });

                                const normalizedSize = String(option).trim();
                                let nextQty = String(
                                  (formik.values as any)?.containerQuantity ?? ""
                                ).trim();
                                // If size isn't 20, force quantity to 1 (only valid option).
                                if (normalizedSize !== "20") {
                                  formik.setFieldValue("containerQuantity", "1");
                                  nextQty = "1";
                                }

                                if (
                                  terminalType === 4 &&
                                  (formik.values.consignmentTypeName === "Import" ||
                                    formik.values.consignmentTypeName === "Export")
                                ) {
                                  const quantity = Number(nextQty);
                                  if (!Number.isNaN(quantity) && quantity > 0) {
                                    syncContainerDetailsToQuantity(quantity, normalizedSize);
                                  }
                                }
                              }
                            }}
                            error={
                              formik.touched.containerSize && Boolean(formik.errors.containerSize)
                            }
                            helperText={formik.touched.containerSize && formik.errors.containerSize}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <CommonAutoCompleteField
                            cssClassName="customTextField"
                            label="Container Quantity"
                            placeholder="Select Container Quantity"
                            name="containerQuantity"
                            optionsType={allcontainerQuantity}
                            getOptionLabel={(option: any) => option || ""}
                            value={
                              allcontainerQuantity.find(
                                (st: any) => st == formik.values.containerQuantity
                              ) || null
                            }
                            onChange={(option: any) => {
                              if (option && option !== "") {
                                formik.setFieldValue("containerQuantity", option);
                                handleValueChange({ target: { value: option } });

                                // For terminal type 4, control how many container detail
                                // sections are visible based on the selected quantity.
                                if (
                                  terminalType === 4 &&
                                  (formik.values.consignmentTypeName === "Import" ||
                                    formik.values.consignmentTypeName === "Export")
                                ) {
                                  const quantity = Number(option);
                                  const containerSize = String(
                                    (formik.values as any)?.containerSize ?? ""
                                  ).trim();
                                  if (!Number.isNaN(quantity) && quantity > 0 && containerSize) {
                                    syncContainerDetailsToQuantity(quantity, containerSize);
                                  }
                                }
                              }
                            }}
                            error={
                              formik.touched.containerQuantity &&
                              Boolean(formik.errors.containerQuantity)
                            }
                            helperText={
                              formik.touched.containerQuantity && formik.errors.containerQuantity
                            }
                          />
                        </Box>
                      </Grid>
                    </>
                  )}
                  {terminalType !== 4 && (
                    <>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <TextField
                            required
                            size="small"
                            fullWidth
                            className="customTextField"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label={
                              formik.values.consignmentTypeName === "Import TIR"
                                ? "Travelling Doc Number/Carnet Number"
                                : "Travelling Doc Number"
                            }
                            name="travellingDocNumber"
                            id="travellingDocNumber"
                            placeholder={
                              formik.values.consignmentTypeName === "Import TIR"
                                ? "Enter Travelling Doc Number/Carnet Number"
                                : "Enter Travelling Doc Number"
                            }
                            value={formik.values.travellingDocNumber}
                            onChange={handleValueChange}
                            error={
                              formik.touched.travellingDocNumber &&
                              Boolean(formik.errors.travellingDocNumber)
                            }
                            helperText={
                              formik.touched.travellingDocNumber &&
                              formik.errors.travellingDocNumber
                            }
                          />
                        </Box>
                      </Grid>
                      {formik.values.consignmentTypeName === "Export" && (
                        <>
                          <Grid item xs={12} md={4}>
                            <Box>
                              <TextField
                                required
                                size="small"
                                fullWidth
                                className="customTextField"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                label="CAMR Number"
                                name="carmNumber"
                                id="carmNumber"
                                placeholder="Enter CAMR Number"
                                value={formik.values.carmNumber}
                                onChange={handleValueChange}
                                error={
                                  formik.touched.carmNumber && Boolean(formik.errors.carmNumber)
                                }
                                helperText={formik.touched.carmNumber && formik.errors.carmNumber}
                              />
                            </Box>
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <Box>
                              <TextField
                                required
                                size="small"
                                fullWidth
                                className="customTextField"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                label="Carnet Number"
                                name="carnetNumber"
                                id="carnetNumber"
                                placeholder="Enter Carnet Number"
                                value={formik.values.carnetNumber}
                                onChange={handleValueChange}
                                error={
                                  formik.touched.carnetNumber && Boolean(formik.errors.carnetNumber)
                                }
                                helperText={
                                  formik.touched.carnetNumber && formik.errors.carnetNumber
                                }
                              />
                            </Box>
                          </Grid>
                        </>
                      )}
                    </>
                  )}

                  {terminalType === 4 &&
                    (formik.values.consignmentTypeName === "Import" ||
                      formik.values.consignmentTypeName === "Export") &&
                    containerList &&
                    containerList?.map((data: any, index: number) => (
                      <>
                        {!isLooseCargoRow(index) && (
                          <Grid item xs={12} md={4}>
                            <Box>
                              <CommonAutoCompleteField
                                cssClassName="customTextField"
                                label={`Importer Name ${index + 1}`}
                                placeholder="Select Importer/Exporter Name"
                                name="importer"
                                optionsType={supplierTypeList}
                                getOptionLabel={(option: any) =>
                                  option.supplierName && option.supplierType
                                    ? `${option.supplierType} - ${option.supplierName}`
                                    : option.supplierName
                                    ? option.supplierName
                                    : ""
                                }
                                renderOption={(option) => (
                                  <span>
                                    {option.supplierName && option.supplierType
                                      ? `${option.supplierType} - ${option.supplierName}`
                                      : option.supplierName
                                      ? option.supplierName
                                      : ""}
                                  </span>
                                )}
                                required
                                value={
                                  supplierTypeList.find(
                                    (st: any) =>
                                      st.id ===
                                      formik.values.containerDetailsListField?.[index]?.importer
                                  ) || null
                                }
                                onChange={(option: any) => {
                                  option && option !== ""
                                    ? formik.setFieldValue(
                                        `containerDetailsListField[${index}].importer`,
                                        option.id
                                      )
                                    : "";
                                }}
                                error={
                                  getIn(formik.touched, `containerDetailsListField.${index}.`) &&
                                  Boolean(
                                    getIn(
                                      formik.errors,
                                      `containerDetailsListField.${index}.importer`
                                    )
                                  )
                                }
                                helperText={
                                  getIn(
                                    formik.touched,
                                    `containerDetailsListField.${index}.importer`
                                  ) &&
                                  getIn(
                                    formik.errors,
                                    `containerDetailsListField.${index}.importer`
                                  )
                                }
                              />
                            </Box>
                          </Grid>
                        )}
                        <Grid
                          item
                          xs={12}
                          md={4}
                          style={{
                            top: "15px",
                            position: "relative",
                            padding: "0 8px",
                          }}
                        >
                          <Box>
                            <TextField
                              required={true}
                              className={"customTextField"}
                              size="small"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onKeyDown={(event: any) => {
                                if (event.key !== "Tab") event.preventDefault();
                              }}
                              label={`Type of Cargo ${index + 1}`}
                              id={`containerDetailsListField.${index}.cargoTypeIds`}
                              name={`containerDetailsListField.${index}.cargoTypeIds`}
                              error={
                                getIn(
                                  formik.touched,
                                  `containerDetailsListField.${index}.cargoTypeIds`
                                ) &&
                                Boolean(
                                  getIn(
                                    formik.errors,
                                    `containerDetailsListField.${index}.cargoTypeIds`
                                  )
                                )
                              }
                              helperText={
                                getIn(
                                  formik.touched,
                                  `containerDetailsListField.${index}.cargoTypeIds`
                                ) &&
                                getIn(
                                  formik.errors,
                                  `containerDetailsListField.${index}.cargoTypeIds`
                                )
                              }
                            />
                            <Box
                              className={classes.multiselectConfigFileCompression}
                              style={{
                                bottom:
                                  getIn(
                                    formik.touched,
                                    `containerDetailsListField.${index}.cargoTypeIds`
                                  ) &&
                                  Boolean(
                                    getIn(
                                      formik.errors,
                                      `containerDetailsListField.${index}.cargoTypeIds`
                                    )
                                  )
                                    ? "55px"
                                    : "35px",
                              }}
                            >
                              <MultiSelect2
                                allValues={typeOfCargoArray}
                                selctedItems={getCargoTypes(index)}
                                displayValue={"name"}
                                placeholder="Select Type of Cargo"
                                onSelect={(selectedList: any) => {
                                  const cargoTypes: string = selectedList
                                    .map((item: any) => (item.id ? item.id : ""))
                                    .toString();
                                  formik.setFieldValue(
                                    `containerDetailsListField[${index}].cargoTypeIds`,
                                    cargoTypes
                                  );
                                }}
                                onRemove={(selectedList: any) => {
                                  const cargoTypes: string = selectedList
                                    .map((item: any) => (item.id ? item.id : ""))
                                    .toString();
                                  formik.setFieldValue(
                                    `containerDetailsListField[${index}].cargoTypeIds`,
                                    cargoTypes
                                  );
                                }}
                                ref={multiselectRef}
                              />
                            </Box>
                          </Box>
                        </Grid>
                      </>
                    ))}

                  {/* add another container button remove for dp */}
                  {/* {terminalType === 4 &&
                    formik.values.consignmentTypeName === "Import" &&
                    (!formik.values.containerQuantity ||
                      (Number(formik.values.containerQuantity) || 0) > containerList.length) && (
                      <Grid item xs={12} md={12}>
                        <Box>
                          <CommonButton
                            isGreen
                            cssClass="customSubmitBtn"
                            disable={
                              id &&
                              JSON.stringify(formik.initialValues) == JSON.stringify(formik.values)
                            }
                            onClick={() => {
                              const newContainer = {
                                containerNumber: "",
                                sealNo: "",
                                cargoTypeIds: "",
                              };
                              const updatedList = [...(containerList || []), newContainer];
                              setContainerList(updatedList);
                              formik.setFieldValue("containerDetailsListField", updatedList);
                            }}
                          >
                            {"Add another container"}
                          </CommonButton>
                        </Box>
                      </Grid>
                    )} */}
                  {/* end of add another container button  */}
                  {/* <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        className="customTextField"
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Slip Number"
                        name="slipNumber"
                        id="slipNumber"
                        placeholder="Enter Slip Number"
                        value={formik.values.slipNumber}
                        onChange={handleValueChange}
                        error={formik.touched.slipNumber && Boolean(formik.errors.slipNumber)}
                        helperText={formik.touched.slipNumber && formik.errors.slipNumber}
                      />
                    </Box>
                  </Grid> */}
                  {/* <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        size="small"
                        fullWidth
                        className="customTextField"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="CRM Number"
                        name="crmNumber"
                        id="crmNumber"
                        placeholder="Enter CRM Number"
                        value={formik.values.crmNumber}
                        onChange={handleValueChange}
                        error={formik.touched.crmNumber && Boolean(formik.errors.crmNumber)}
                        helperText={formik.touched.crmNumber && formik.errors.crmNumber}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        size="small"
                        fullWidth
                        className="customTextField"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="E-Form Number"
                        name="eFormNumber"
                        id="eFormNumber"
                        placeholder="Enter E-Form Number"
                        value={formik.values.eFormNumber}
                        onChange={handleValueChange}
                        error={formik.touched.eFormNumber && Boolean(formik.errors.eFormNumber)}
                        helperText={formik.touched.eFormNumber && formik.errors.eFormNumber}
                      />
                    </Box>
                  </Grid> */}
                  {/* container Details Section */}
                  {formik.values.consignmentTypeName === "LCL-Empty" && (
                    <Grid item xs={12} md={12}>
                      <Box>
                        <CommonButton
                          isGreen
                          cssClass="customSubmitBtn"
                          disable={
                            id &&
                            JSON.stringify(formik.initialValues) == JSON.stringify(formik.values)
                          }
                          onClick={() => {
                            const newContainer = {
                              containerNumber: "",
                              sealNo: "",
                              cargoTypeIds: "",
                            };
                            setContainerList((prev: any[]) => [...prev, newContainer]);
                            formik.setFieldValue("containerDetailsListField", [
                              ...(formik.values.containerDetailsListField || []),
                              newContainer,
                            ]);
                          }}
                        >
                          {"Add container"}
                        </CommonButton>
                      </Box>
                    </Grid>
                  )}
                  {containerList &&
                    containerList?.map((data: any, index: number) => (
                      <>
                        <Grid item md={12} className={classes.sectionHeading}>
                          <Box
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography>Container&apos;s Details : {`${index + 1}`}</Typography>
                            {/* {terminalType === 4 && containerList.length > 1 && (
                              <CommonButton
                                cssClass="customDeleteBtn"
                                onClick={() => handleDeleteContainer(index)}
                                disable={containerList.length === 1}
                              >
                                {"Remove this container"}
                              </CommonButton>
                            )} */}
                          </Box>
                        </Grid>
                        {formik.values.consignmentTypeName !== "LCL-Empty" && (
                          <>
                            {terminalType !== 4 &&
                            formik.values.consignmentTypeName === "Import" ? (
                              <Grid item xs={12} md={4}>
                                <CommonTextFieldDate
                                  cssClassName={`${classes.dateTime} ${"customTextField"}`}
                                  outerCss={true}
                                  datePickerRef={datePickerRef}
                                  label={"Entry Date and Time"}
                                  name={`containerDetailsListField.${index}.entryDate`}
                                  required={true}
                                  value={
                                    (formik.values.containerDetailsListField ?? [])?.[index]
                                      ?.entryDate ||
                                    (formik.values as any).entryDate ||
                                    formik.values.dateTime ||
                                    ""
                                  }
                                  onChange={(e: any) => {
                                    formik.setFieldValue(
                                      `containerDetailsListField.${index}.entryDate`,
                                      e
                                    );
                                  }}
                                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                                  isReadOnly={false}
                                  error={
                                    getIn(
                                      formik.touched,
                                      `containerDetailsListField.${index}.entryDate`
                                    ) &&
                                    Boolean(
                                      getIn(
                                        formik.errors,
                                        `containerDetailsListField.${index}.entryDate`
                                      )
                                    )
                                  }
                                  helperText={
                                    getIn(
                                      formik.touched,
                                      `containerDetailsListField.${index}.entryDate`
                                    ) &&
                                    getIn(
                                      formik.errors,
                                      `containerDetailsListField.${index}.entryDate`
                                    )
                                  }
                                />
                              </Grid>
                            ) : null}
                            {terminalType !== 4 && (
                              <Grid item xs={12} md={4}>
                                <Box>
                                  <CommonAutoCompleteField
                                    required={terminalType !== 4}
                                    disabled={formik.values.consignmentTypeName === "Empty-Export"}
                                    cssClassName="customTextField"
                                    label="Container Size (Feet)"
                                    name={`containerDetailsListField.${index}.containerSize`}
                                    optionsType={containerSIzeList}
                                    placeholder="Select Container Size"
                                    getOptionLabel={(option: any) => option || ""}
                                    value={
                                      containerSIzeList.find(
                                        (st: any) =>
                                          st ==
                                          (formik.values.containerDetailsListField ?? [])[index]
                                            ?.containerSize
                                      ) || null
                                    }
                                    onChange={(option: any) => {
                                      if (option && option !== "") {
                                        formik.setFieldValue(
                                          `containerDetailsListField.${index}.containerSize`,
                                          option
                                        );
                                        handleValueChange({ target: { value: option } });
                                      }
                                    }}
                                    error={
                                      getIn(
                                        formik.touched,
                                        `containerDetailsListField.${index}.containerSize`
                                      ) &&
                                      Boolean(
                                        getIn(
                                          formik.errors,
                                          `containerDetailsListField.${index}.containerSize`
                                        )
                                      )
                                    }
                                    helperText={
                                      getIn(
                                        formik.touched,
                                        `containerDetailsListField.${index}.containerSize`
                                      ) &&
                                      getIn(
                                        formik.errors,
                                        `containerDetailsListField.${index}.containerSize`
                                      )
                                    }
                                  />
                                </Box>
                              </Grid>
                            )}
                            {formik.values.consignmentTypeName !== "Empty-Export" && (
                              <Grid item xs={12} md={4}>
                                <Box>
                                  <CommonAutoCompleteField
                                    required={
                                      (terminalType !== 4 &&
                                        formik.values.consignmentTypeName === "Export") ||
                                      (formik.values.containerDetailsListField ?? [])[index]
                                        ?.containerLoadType === "CY"
                                    }
                                    cssClassName="customTextField"
                                    label="Container Type"
                                    name={`containerDetailsListField.${index}.cargoType`}
                                    optionsType={getContainerTypeList(terminalType)}
                                    placeholder="Select Container Type"
                                    getOptionLabel={(option: any) => option || ""}
                                    value={
                                      getContainerTypeList(terminalType).find(
                                        (st: any) =>
                                          st ===
                                          (formik.values.containerDetailsListField ?? [])[index]
                                            ?.cargoType
                                      ) || null
                                    }
                                    onChange={(option: any) => {
                                      if (option && option !== "") {
                                        formik.setFieldValue(
                                          `containerDetailsListField.${index}.cargoType`,
                                          option
                                        );
                                        handleValueChange({ target: { value: option } });
                                      }
                                    }}
                                    error={
                                      getIn(
                                        formik.touched,
                                        `containerDetailsListField.${index}.cargoType`
                                      ) &&
                                      Boolean(
                                        getIn(
                                          formik.errors,
                                          `containerDetailsListField.${index}.cargoType`
                                        )
                                      )
                                    }
                                    helperText={
                                      getIn(
                                        formik.touched,
                                        `containerDetailsListField.${index}.cargoType`
                                      ) &&
                                      getIn(
                                        formik.errors,
                                        `containerDetailsListField.${index}.cargoType`
                                      )
                                    }
                                  />
                                </Box>
                              </Grid>
                            )}
                            {terminalType !== 4 && (
                              <Grid item xs={12} md={4}>
                                <Box>
                                  <CommonAutoCompleteField
                                    cssClassName="customTextField"
                                    required={terminalType !== 4}
                                    disabled={formik.values.consignmentTypeName === "Empty-Export"}
                                    label="Container Load Type"
                                    name={`containerDetailsListField.${index}.containerLoadType`}
                                    optionsType={containerLoadTypeList}
                                    placeholder="Select Container Load Type"
                                    getOptionLabel={(option: any) => option || ""}
                                    value={
                                      containerLoadTypeList.find(
                                        (st: any) =>
                                          st ==
                                          (formik.values.containerDetailsListField ?? [])[index]
                                            ?.containerLoadType
                                      ) || null
                                    }
                                    onChange={(option: any) => {
                                      if (option && option !== "") {
                                        formik.setFieldValue(
                                          `containerDetailsListField.${index}.containerLoadType`,
                                          option
                                        );
                                        handleValueChange({ target: { value: option } });
                                      }
                                    }}
                                    error={
                                      getIn(
                                        formik.touched,
                                        `containerDetailsListField.${index}.containerLoadType`
                                      ) &&
                                      Boolean(
                                        getIn(
                                          formik.errors,
                                          `containerDetailsListField.${index}.containerLoadType`
                                        )
                                      )
                                    }
                                    helperText={
                                      getIn(
                                        formik.touched,
                                        `containerDetailsListField.${index}.containerLoadType`
                                      ) &&
                                      getIn(
                                        formik.errors,
                                        `containerDetailsListField.${index}.containerLoadType`
                                      )
                                    }
                                  />
                                </Box>
                              </Grid>
                            )}
                            {terminalType !== 4 && formik.values.consignmentTypeName === "Import" && (
                              <Grid item xs={12} md={4}>
                                <Box>
                                  <CommonAutoCompleteField
                                    cssClassName="customTextField"
                                    label={`Forwarder ${index + 1}`}
                                    placeholder="Select Forwarder Name"
                                    name={`containerDetailsListField.${index}.forwarder`}
                                    optionsType={allPartyNameRows}
                                    getOptionLabel={(option) => option.name || ""}
                                    value={
                                      allPartyNameRows.find(
                                        (st: any) =>
                                          String(st.id) ===
                                          String(
                                            (formik.values.containerDetailsListField ?? [])[index]
                                              ?.forwarder
                                          )
                                      ) || null
                                    }
                                    onChange={(option: any) => {
                                      const forwarderId = String(option?.id ?? "");
                                      formik.setFieldValue(
                                        `containerDetailsListField.${index}.forwarder`,
                                        forwarderId
                                      );
                                      handleValueChange({ target: { value: forwarderId } });
                                    }}
                                    error={
                                      getIn(
                                        formik.touched,
                                        `containerDetailsListField.${index}.forwarder`
                                      ) &&
                                      Boolean(
                                        getIn(
                                          formik.errors,
                                          `containerDetailsListField.${index}.forwarder`
                                        )
                                      )
                                    }
                                    helperText={
                                      getIn(
                                        formik.touched,
                                        `containerDetailsListField.${index}.forwarder`
                                      ) &&
                                      getIn(
                                        formik.errors,
                                        `containerDetailsListField.${index}.forwarder`
                                      )
                                    }
                                  />
                                </Box>
                              </Grid>
                            )}
                          </>
                        )}
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              className="customTextField"
                              type="text"
                              size="small"
                              required={
                                formik.values.consignmentTypeName === "Export" ||
                                formik.values.consignmentTypeName === "Import"
                              }
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label={`Container Number ${index + 1}`}
                              name={`containerDetailsListField.${index}.containerNumber`}
                              placeholder="Enter Container Number"
                              disabled={
                                terminalType !== 4 &&
                                (formik.values.consignmentTypeName === "Import" ||
                                  formik.values.consignmentTypeName === "Empty-Export")
                              }
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]
                                      ?.containerNumber ||
                                    data?.containerNumber ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(
                                  formik.touched,
                                  `containerDetailsListField.${index}.containerNumber`
                                ) &&
                                Boolean(
                                  getIn(
                                    formik.errors,
                                    `containerDetailsListField.${index}.containerNumber`
                                  )
                                )
                              }
                              helperText={
                                getIn(
                                  formik.touched,
                                  `containerDetailsListField.${index}.containerNumber`
                                ) &&
                                getIn(
                                  formik.errors,
                                  `containerDetailsListField.${index}.containerNumber`
                                )
                              }
                              // value={data?.containerNumber || ""}
                            />
                          </Box>
                        </Grid>
                        {formik.values.consignmentTypeName !== "LCL-Empty" && (
                          <>
                            <Grid item xs={12} md={4}>
                              <Box>
                                <TextField
                                  className="customTextField"
                                  type="text"
                                  size="small"
                                  fullWidth
                                  variant="outlined"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  label={`Container Seal Number ${index + 1}`}
                                  name={`containerDetailsListField.${index}.sealNo`}
                                  placeholder="Enter Container Seal Number"
                                  disabled={terminalType !== 4}
                                  value={
                                    formik.values.containerDetailsListField
                                      ? formik.values.containerDetailsListField[index]?.sealNo ||
                                        data?.sealNo ||
                                        ""
                                      : ""
                                  }
                                  onChange={handleValueChange}
                                  // value={data?.sealNumber || ""}
                                />
                              </Box>
                            </Grid>
                            {terminalType === 4 && isLooseCargoRow(index) && (
                              <Grid item xs={12} md={4}>
                                <Box>
                                  <TextField
                                    className="customTextField"
                                    type="number"
                                    size="small"
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    label="No of Indexes"
                                    name={`containerDetailsListField.${index}.noOfIndexes`}
                                    placeholder="Enter number of indexes"
                                    value={
                                      formik.values.containerDetailsListField?.[index]
                                        ?.noOfIndexes ?? ""
                                    }
                                    onChange={(e) => handleNoOfIndexesChange(index, e.target.value)}
                                    inputProps={{ min: 0, max: 50 }}
                                  />
                                </Box>
                              </Grid>
                            )}
                            {terminalType === 4 &&
                              isLooseCargoRow(index) &&
                              (Number(
                                formik.values.containerDetailsListField?.[index]?.noOfIndexes
                              ) > 0 ||
                                (
                                  formik.values.containerDetailsListField?.[index]
                                    ?.containerIndexesList ?? []
                                ).length > 0) && (
                                <Grid item xs={12}>
                                  <Box mt={1} mb={1}>
                                    <Typography variant="subtitle1">
                                      Container indexes list
                                    </Typography>
                                  </Box>
                                  {(
                                    formik.values.containerDetailsListField?.[index]
                                      ?.containerIndexesList ?? []
                                  ).map((_row: any, subIdx: number) => (
                                    <Grid
                                      container
                                      spacing={2}
                                      key={`idx-${index}-${subIdx}`}
                                      style={{ marginBottom: 8 }}
                                    >
                                      <Grid item xs={12} md={4}>
                                        <Box>
                                          <TextField
                                            className="customTextField"
                                            type="text"
                                            size="small"
                                            fullWidth
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            label={`Index Number ${subIdx + 1}`}
                                            name={`containerDetailsListField.${index}.containerIndexesList.${subIdx}.indexNo`}
                                            placeholder="Enter Index Number"
                                            value={
                                              formik.values.containerDetailsListField?.[index]
                                                ?.containerIndexesList?.[subIdx]?.indexNo ?? ""
                                            }
                                            onChange={handleValueChange}
                                          />
                                        </Box>
                                      </Grid>
                                      <Grid item xs={12} md={4}>
                                        <Box>
                                          <CommonAutoCompleteField
                                            cssClassName="customTextField"
                                            label={`Importer ${subIdx + 1}`}
                                            placeholder="Select Importer"
                                            name={`containerDetailsListField.${index}.containerIndexesList.${subIdx}.importerId`}
                                            optionsType={supplierTypeList}
                                            getOptionLabel={(option: any) =>
                                              option.supplierName && option.supplierType
                                                ? `${option.supplierType} - ${option.supplierName}`
                                                : option.supplierName
                                                ? option.supplierName
                                                : ""
                                            }
                                            renderOption={(option) => (
                                              <span>
                                                {option.supplierName && option.supplierType
                                                  ? `${option.supplierType} - ${option.supplierName}`
                                                  : option.supplierName
                                                  ? option.supplierName
                                                  : ""}
                                              </span>
                                            )}
                                            value={
                                              supplierTypeList.find(
                                                (st: any) =>
                                                  st.id ===
                                                  formik.values.containerDetailsListField?.[index]
                                                    ?.containerIndexesList?.[subIdx]?.importerId
                                              ) || null
                                            }
                                            onChange={(option: any) => {
                                              option && option !== ""
                                                ? formik.setFieldValue(
                                                    `containerDetailsListField.${index}.containerIndexesList.${subIdx}.importerId`,
                                                    option.id
                                                  )
                                                : formik.setFieldValue(
                                                    `containerDetailsListField.${index}.containerIndexesList.${subIdx}.importerId`,
                                                    ""
                                                  );
                                              setIsDirty(true);
                                            }}
                                          />
                                        </Box>
                                      </Grid>
                                      <Grid item xs={12} md={4}>
                                        <Box>
                                          <TextField
                                            className="customTextField"
                                            type="text"
                                            size="small"
                                            fullWidth
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            label={`Index Weight ${subIdx + 1}`}
                                            name={`containerDetailsListField.${index}.containerIndexesList.${subIdx}.indexWeight`}
                                            placeholder="Enter weight"
                                            value={
                                              formik.values.containerDetailsListField?.[index]
                                                ?.containerIndexesList?.[subIdx]?.indexWeight ?? ""
                                            }
                                            onChange={handleValueChange}
                                          />
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  ))}
                                </Grid>
                              )}
                            {formik.values.consignmentTypeName !== "Empty-Export" &&
                              terminalType !== 4 && (
                                <Grid item xs={12} md={4}>
                                  <Box>
                                    <TextField
                                      className="customTextField"
                                      type="text"
                                      size="small"
                                      fullWidth
                                      variant="outlined"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      label={`Container Gross Weight ${index + 1}`}
                                      name={`containerDetailsListField.${index}.containerGrossWeight`}
                                      placeholder="Enter Container Gross Weight"
                                      disabled={terminalType !== 4}
                                      value={
                                        formik.values.containerDetailsListField
                                          ? formik.values.containerDetailsListField[index]
                                              ?.containerGrossWeight ||
                                            data?.containerGrossWeight ||
                                            ""
                                          : ""
                                      }
                                      onChange={handleValueChange}
                                    />
                                  </Box>
                                </Grid>
                              )}
                            {terminalType === 1 && (
                              <>
                                {formik.values.consignmentTypeName !== "Empty-Export" && (
                                  <Grid item xs={12} md={4}>
                                    <Box>
                                      <FormControlLabel
                                        control={
                                          <Switch
                                            checked={Boolean(
                                              formik.values.containerDetailsListField?.[index]
                                                ?.isDemurrageApplied
                                            )}
                                            onChange={handleValueChange}
                                            name={`containerDetailsListField.${index}.isDemurrageApplied`}
                                            color="primary"
                                          />
                                        }
                                        label={`Is Demurrage Applied ${index + 1}`}
                                      />
                                    </Box>
                                  </Grid>
                                )}

                                {formik.values.containerDetailsListField?.[index]
                                  ?.isDemurrageApplied && (
                                  <Grid item xs={12} md={4}>
                                    <Box>
                                      <TextField
                                        size="small"
                                        fullWidth
                                        className="customTextField"
                                        variant="outlined"
                                        type="number"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        label={`Number of Days ${index + 1}`}
                                        name={`containerDetailsListField.${index}.noOfDays`}
                                        id={`containerDetailsListField.${index}.noOfDays`}
                                        placeholder="Enter Days Number"
                                        value={
                                          formik.values.containerDetailsListField?.[index]
                                            ?.noOfDays || ""
                                        }
                                        onChange={handleValueChange}
                                        error={
                                          getIn(
                                            formik.touched,
                                            `containerDetailsListField.${index}.`
                                          ) &&
                                          Boolean(
                                            getIn(
                                              formik.errors,
                                              `containerDetailsListField.${index}.noOfDays`
                                            )
                                          )
                                        }
                                        helperText={
                                          getIn(
                                            formik.touched,
                                            `containerDetailsListField.${index}.noOfDays`
                                          ) &&
                                          getIn(
                                            formik.errors,
                                            `containerDetailsListField.${index}.noOfDays`
                                          )
                                        }
                                      />
                                    </Box>
                                  </Grid>
                                )}
                              </>
                            )}

                            {/* <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="RO Number"
                              id={`containerDetailsListField.${index}.roNumber`}
                              placeholder="Enter RO Number"
                              disabled={false}
                              name={`containerDetailsListField.${index}.roNumber`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.roNumber ||
                                    data?.roNumber ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              // error={
                              //   formik.touched.driverFatherName && Boolean(formik.errors.driverFatherName)
                              // }
                              // helperText={
                              //   formik.touched.driverFatherName && formik.errors.driverFatherName
                              // }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Movement"
                              id={`containerDetailsListField.${index}.movement`}
                              placeholder="Enter Movement"
                              disabled={false}
                              name={`containerDetailsListField.${index}.movement`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.movement ||
                                    data?.movement ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "movement") &&
                                Boolean(getIn(formik.errors, "movement"))
                              }
                              helperText={
                                getIn(formik.touched, "movement") &&
                                getIn(formik.errors, "movement")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Cost Center"
                              id={`containerDetailsListField.${index}.costCenter`}
                              placeholder="Enter Cost Center"
                              disabled={false}
                              name={`containerDetailsListField.${index}.costCenter`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.costCenter ||
                                    data?.costCenter ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "costCenter") &&
                                Boolean(getIn(formik.errors, "costCenter"))
                              }
                              helperText={
                                getIn(formik.touched, "costCenter") &&
                                getIn(formik.errors, "costCenter")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Activity"
                              id={`containerDetailsListField.${index}.activity`}
                              placeholder="Enter Activity"
                              disabled={false}
                              name={`containerDetailsListField.${index}.activity`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.activity ||
                                    data?.activity ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "activity") &&
                                Boolean(getIn(formik.errors, "activity"))
                              }
                              helperText={
                                getIn(formik.touched, "activity") &&
                                getIn(formik.errors, "activity")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Line"
                              id={`containerDetailsListField.${index}.line`}
                              placeholder="Enter Line"
                              disabled={false}
                              name={`containerDetailsListField.${index}.line`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.line ||
                                    data?.line ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "line") &&
                                Boolean(getIn(formik.errors, "line"))
                              }
                              helperText={
                                getIn(formik.touched, "line") && getIn(formik.errors, "line")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Sub Line"
                              id={`containerDetailsListField.${index}.subLine`}
                              placeholder="Enter Sub Line"
                              disabled={false}
                              name={`containerDetailsListField.${index}.subLine`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.subLine ||
                                    data?.subLine ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "subLine") &&
                                Boolean(getIn(formik.errors, "subLine"))
                              }
                              helperText={
                                getIn(formik.touched, "subLine") && getIn(formik.errors, "subLine")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Client"
                              id={`containerDetailsListField.${index}.client`}
                              placeholder="Enter Client"
                              disabled={false}
                              name={`containerDetailsListField.${index}.client`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.client ||
                                    data?.client ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "client") &&
                                Boolean(getIn(formik.errors, "client"))
                              }
                              helperText={
                                getIn(formik.touched, "client") && getIn(formik.errors, "client")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Cash Client"
                              id={`containerDetailsListField.${index}.cashClient`}
                              placeholder="Enter Cash Client"
                              disabled={false}
                              name={`containerDetailsListField.${index}.cashClient`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.cashClient ||
                                    data?.cashClient ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "cashClient") &&
                                Boolean(getIn(formik.errors, "cashClient"))
                              }
                              helperText={
                                getIn(formik.touched, "cashClient") &&
                                getIn(formik.errors, "cashClient")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="LP/ Booking No"
                              id={`containerDetailsListField.${index}.bookingNumber`}
                              placeholder="Enter LP/ Booking No"
                              disabled={false}
                              name={`containerDetailsListField.${index}.bookingNumber`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.bookingNumber ||
                                    data?.bookingNumber ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "bookingNumber") &&
                                Boolean(getIn(formik.errors, "bookingNumber"))
                              }
                              helperText={
                                getIn(formik.touched, "bookingNumber") &&
                                getIn(formik.errors, "bookingNumber")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Shipper"
                              id={`containerDetailsListField.${index}.shipper`}
                              placeholder="Enter Shipper"
                              disabled={false}
                              name={`containerDetailsListField.${index}.shipper`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.shipper ||
                                    data?.shipper ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "shipper") &&
                                Boolean(getIn(formik.errors, "shipper"))
                              }
                              helperText={
                                getIn(formik.touched, "shipper") && getIn(formik.errors, "shipper")
                              }
                            />
                          </Box>
                        </Grid> */}
                            {terminalType !== 4 &&
                              formik.values.consignmentTypeName === "Import" &&
                              (formik.values.containerDetailsListField ?? [])[index]
                                ?.containerLoadType === "CY" && (
                                // <Grid item xs={12} md={4}>
                                //   <Box>
                                //     <CommonAutoCompleteField
                                //       cssClassName="customTextField"
                                //       disabled={false}
                                //       label="Consignee"
                                //       name={`containerDetailsListField.${index}.consignee`}
                                //       optionsType={consigneeList.map((c) => c.consignee)}
                                //       placeholder="Select Consignee"
                                //       getOptionLabel={(option: any) => option || ""}
                                //       value={
                                //         consigneeList.find(
                                //           (c) =>
                                //             c.consignee ===
                                //             (formik.values.containerDetailsListField ?? [])[index]
                                //               ?.consignee
                                //         )?.consignee ||
                                //         (formik.values.containerDetailsListField ?? [])[index]
                                //           ?.consignee ||
                                //         data?.consignee ||
                                //         null
                                //       }
                                //       onChange={(option: any) => {
                                //         if (option !== null && option !== undefined) {
                                //           formik.setFieldValue(
                                //             `containerDetailsListField.${index}.consignee`,
                                //             option
                                //           );
                                //           handleValueChange({ target: { value: option } });
                                //         }
                                //       }}
                                //       error={
                                //         getIn(
                                //           formik.touched,
                                //           `containerDetailsListField.${index}.consignee`
                                //         ) &&
                                //         Boolean(
                                //           getIn(
                                //             formik.errors,
                                //             `containerDetailsListField.${index}.consignee`
                                //           )
                                //         )
                                //       }
                                //       helperText={
                                //         getIn(
                                //           formik.touched,
                                //           `containerDetailsListField.${index}.consignee`
                                //         ) &&
                                //         getIn(
                                //           formik.errors,
                                //           `containerDetailsListField.${index}.consignee`
                                //         )
                                //       }
                                //     />
                                //   </Box>
                                // </Grid>
                                <Grid item xs={12} md={4}>
                                  <Box>
                                    <CommonAutoCompleteField
                                      cssClassName="customTextField"
                                      disabled={false}
                                      required
                                      label="Consignee"
                                      name={`containerDetailsListField.${index}.consigneeId`}
                                      optionsType={consigneeList}
                                      placeholder="Select Consignee"
                                      getOptionLabel={(option: any) => option?.name || ""}
                                      value={
                                        Array.isArray(consigneeList)
                                          ? consigneeList.find(
                                              (c) =>
                                                String(c.id) ===
                                                String(
                                                  (formik.values.containerDetailsListField ?? [])[
                                                    index
                                                  ]?.consigneeId ?? ""
                                                )
                                            ) || null
                                          : null
                                      }
                                      onChange={(option: any) => {
                                        if (option) {
                                          const idStr = String(option.id);
                                          formik.setFieldValue(
                                            `containerDetailsListField.${index}.consigneeId`,
                                            idStr
                                          );
                                          formik.setFieldValue(
                                            `containerDetailsListField.${index}.consignee`,
                                            idStr
                                          );
                                          handleValueChange({
                                            target: { value: idStr },
                                          });
                                        } else {
                                          formik.setFieldValue(
                                            `containerDetailsListField.${index}.consigneeId`,
                                            null
                                          );
                                          formik.setFieldValue(
                                            `containerDetailsListField.${index}.consignee`,
                                            ""
                                          );
                                        }
                                      }}
                                      error={
                                        getIn(
                                          formik.touched,
                                          `containerDetailsListField.${index}.consigneeId`
                                        ) &&
                                        Boolean(
                                          getIn(
                                            formik.errors,
                                            `containerDetailsListField.${index}.consigneeId`
                                          )
                                        )
                                      }
                                      helperText={
                                        getIn(
                                          formik.touched,
                                          `containerDetailsListField.${index}.consigneeId`
                                        ) &&
                                        getIn(
                                          formik.errors,
                                          `containerDetailsListField.${index}.consigneeId`
                                        )
                                      }
                                    />
                                  </Box>
                                </Grid>
                              )}
                            {terminalType !== 4 &&
                              formik.values.consignmentTypeName === "Empty-Export" && (
                                <Grid item xs={12} md={4}>
                                  <Box>
                                    <TextField
                                      size="small"
                                      fullWidth
                                      className="customTextField"
                                      variant="outlined"
                                      InputLabelProps={{ shrink: true }}
                                      label="Consignee"
                                      id={`containerDetailsListField.${index}.consignee`}
                                      placeholder="Enter Consignee"
                                      disabled
                                      name={`containerDetailsListField.${index}.consignee`}
                                      value={(() => {
                                        const row = (formik.values.containerDetailsListField ?? [])[
                                          index
                                        ];
                                        const idOrConsignee = row?.consigneeId ?? row?.consignee;
                                        if (
                                          idOrConsignee != null &&
                                          idOrConsignee !== "" &&
                                          Array.isArray(consigneeList)
                                        ) {
                                          const found = consigneeList.find(
                                            (c) => String(c.id) === String(idOrConsignee)
                                          );
                                          if (found) return found.name;
                                        }
                                        return row?.consignee ?? data?.consignee ?? "";
                                      })()}
                                      error={
                                        getIn(
                                          formik.touched,
                                          `containerDetailsListField.${index}.consignee`
                                        ) &&
                                        Boolean(
                                          getIn(
                                            formik.errors,
                                            `containerDetailsListField.${index}.consignee`
                                          )
                                        )
                                      }
                                      helperText={
                                        getIn(
                                          formik.touched,
                                          `containerDetailsListField.${index}.consignee`
                                        ) &&
                                        getIn(
                                          formik.errors,
                                          `containerDetailsListField.${index}.consignee`
                                        )
                                      }
                                    />
                                  </Box>
                                </Grid>
                              )}
                            {terminalType !== 4 && (
                              <>
                                <Grid item xs={12} md={4}>
                                  <Box>
                                    <TextField
                                      size="small"
                                      fullWidth
                                      className="customTextField"
                                      variant="outlined"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      label="Transporter"
                                      id={`containerDetailsListField.${index}.transporter`}
                                      placeholder="Enter Transporter"
                                      disabled={terminalType !== 4}
                                      name={`containerDetailsListField.${index}.transporter`}
                                      value={
                                        formik.values.containerDetailsListField
                                          ? formik.values.containerDetailsListField[index]
                                              ?.transporter ||
                                            data?.transporter ||
                                            ""
                                          : ""
                                      }
                                      onChange={handleValueChange}
                                      error={
                                        getIn(formik.touched, "transporter") &&
                                        Boolean(getIn(formik.errors, "transporter"))
                                      }
                                      helperText={
                                        getIn(formik.touched, "transporter") &&
                                        getIn(formik.errors, "transporter")
                                      }
                                    />
                                  </Box>
                                </Grid>
                              </>
                            )}

                            {/* <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Forwarder"
                              id={`containerDetailsListField.${index}.forwarder`}
                              placeholder="Enter Forwarder"
                              disabled={false}
                              name={`containerDetailsListField.${index}.forwarder`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.forwarder ||
                                    data?.forwarder ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "forwarder") &&
                                Boolean(getIn(formik.errors, "forwarder"))
                              }
                              helperText={
                                getIn(formik.touched, "forwarder") &&
                                getIn(formik.errors, "forwarder")
                              }
                            />
                          </Box>
                        </Grid> */}
                            {terminalType !== 4 && (
                              <>
                                <Grid item xs={12} md={4}>
                                  <Box>
                                    <TextField
                                      size="small"
                                      fullWidth
                                      className="customTextField"
                                      variant="outlined"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      label="Vessel"
                                      id={`containerDetailsListField.${index}.vessel`}
                                      placeholder="Enter Vessel"
                                      disabled={terminalType !== 4}
                                      name={`containerDetailsListField.${index}.vessel`}
                                      value={
                                        formik.values.containerDetailsListField
                                          ? formik.values.containerDetailsListField[index]
                                              ?.vessel ||
                                            data?.vessel ||
                                            ""
                                          : 0
                                      }
                                      onChange={handleValueChange}
                                      error={
                                        getIn(formik.touched, "vessel") &&
                                        Boolean(getIn(formik.errors, "vessel"))
                                      }
                                      helperText={
                                        getIn(formik.touched, "vessel") &&
                                        getIn(formik.errors, "vessel")
                                      }
                                    />
                                  </Box>
                                </Grid>
                              </>
                            )}
                            {/* <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="C&F Agent"
                              id={`containerDetailsListField.${index}.cfAgent`}
                              placeholder="Enter C&F Agent"
                              disabled={false}
                              name={`containerDetailsListField.${index}.cfAgent`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.cfAgent ||
                                    data?.cfAgent ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "cfAgent") &&
                                Boolean(getIn(formik.errors, "cfAgent"))
                              }
                              helperText={
                                getIn(formik.touched, "cfAgent") && getIn(formik.errors, "cfAgent")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Previous Location"
                              id={`containerDetailsListField.${index}.previousLocation`}
                              placeholder="Enter Previous Location"
                              disabled={false}
                              name={`containerDetailsListField.${index}.previousLocation`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]
                                      ?.previousLocation ||
                                    data?.previousLocation ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "previousLocation") &&
                                Boolean(getIn(formik.errors, "previousLocation"))
                              }
                              helperText={
                                getIn(formik.touched, "previousLocation") &&
                                getIn(formik.errors, "previousLocation")
                              }
                            />
                          </Box>
                        </Grid> */}
                            {terminalType !== 4 && (
                              <>
                                <Grid item xs={12} md={4}>
                                  <Box>
                                    <TextField
                                      size="small"
                                      fullWidth
                                      className="customTextField"
                                      variant="outlined"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      label="Voyage"
                                      id={`containerDetailsListField.${index}.voyage`}
                                      placeholder="Enter Voyage"
                                      disabled={terminalType !== 4}
                                      name={`containerDetailsListField.${index}.voyage`}
                                      value={
                                        formik.values.containerDetailsListField
                                          ? formik.values.containerDetailsListField[index]
                                              ?.voyage ||
                                            data?.voyage ||
                                            ""
                                          : ""
                                      }
                                      onChange={handleValueChange}
                                      error={
                                        getIn(formik.touched, "voyage") &&
                                        Boolean(getIn(formik.errors, "voyage"))
                                      }
                                      helperText={
                                        getIn(formik.touched, "voyage") &&
                                        getIn(formik.errors, "voyage")
                                      }
                                    />
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                  <Box>
                                    <TextField
                                      size="small"
                                      fullWidth
                                      className="customTextField"
                                      variant="outlined"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      label="Destination"
                                      id={`containerDetailsListField.${index}.destination`}
                                      placeholder="Enter Destination"
                                      disabled={terminalType !== 4}
                                      name={`containerDetailsListField.${index}.destination`}
                                      value={
                                        formik.values.containerDetailsListField
                                          ? formik.values.containerDetailsListField[index]
                                              ?.destination ||
                                            data?.destination ||
                                            ""
                                          : ""
                                      }
                                      // onChange={handleValueChange}
                                      onChange={formik.handleChange}
                                      error={
                                        getIn(formik.touched, "destination") &&
                                        Boolean(getIn(formik.errors, "destination"))
                                      }
                                      helperText={
                                        getIn(formik.touched, "destination") &&
                                        getIn(formik.errors, "destination")
                                      }
                                    />
                                  </Box>
                                </Grid>
                              </>
                            )}
                            {/* <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Doc Ref Number"
                              id={`containerDetailsListField.${index}.docRefNumber`}
                              placeholder="Enter Doc Ref Number"
                              disabled={false}
                              name={`containerDetailsListField.${index}.docRefNumber`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.docRefNumber ||
                                    data?.docRefNumber ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "docRefNumber") &&
                                Boolean(getIn(formik.errors, "docRefNumber"))
                              }
                              helperText={
                                getIn(formik.touched, "docRefNumber") &&
                                getIn(formik.errors, "docRefNumber")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Discharge Port"
                              id={`containerDetailsListField.${index}.dischargePort`}
                              placeholder="Enter Discharge Port"
                              disabled={false}
                              name={`containerDetailsListField.${index}.dischargePort`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.dischargePort ||
                                    data?.dischargePort ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "dischargePort") &&
                                Boolean(getIn(formik.errors, "dischargePort"))
                              }
                              helperText={
                                getIn(formik.touched, "dischargePort") &&
                                getIn(formik.errors, "dischargePort")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Pol"
                              id={`containerDetailsListField.${index}.pol`}
                              placeholder="Enter Pol"
                              disabled={false}
                              name={`containerDetailsListField.${index}.pol`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.pol ||
                                    data?.pol ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "pol") && Boolean(getIn(formik.errors, "pol"))
                              }
                              helperText={
                                getIn(formik.touched, "pol") && getIn(formik.errors, "pol")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Shift"
                              id={`containerDetailsListField.${index}.shift`}
                              placeholder="Enter Shift"
                              disabled={false}
                              name={`containerDetailsListField.${index}.shift`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.shift ||
                                    data?.shift ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "shift") &&
                                Boolean(getIn(formik.errors, "shift"))
                              }
                              helperText={
                                getIn(formik.touched, "shift") && getIn(formik.errors, "shift")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={Boolean(
                                    formik.values.containerDetailsListField
                                      ? formik.values.containerDetailsListField[index]?.applyStorage
                                      : true
                                  )}
                                  onChange={handleValueChange}
                                  name={`containerDetailsListField.${index}.applyStorage`}
                                  color="primary"
                                />
                              }
                              label="Apply Storage"
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="SCAC Code"
                              id={`containerDetailsListField.${index}.scacCode`}
                              placeholder="Enter SCAC Code"
                              disabled={false}
                              name={`containerDetailsListField.${index}.scacCode`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.scacCode ||
                                    data?.scacCode ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "scacCode") &&
                                Boolean(getIn(formik.errors, "scacCode"))
                              }
                              helperText={
                                getIn(formik.touched, "scacCode") &&
                                getIn(formik.errors, "scacCode")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Charges Status"
                              id={`containerDetailsListField.${index}.chargesStatus`}
                              placeholder="Enter Charges Status"
                              disabled={false}
                              name={`containerDetailsListField.${index}.chargesStatus`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.chargesStatus ||
                                    data?.chargesStatus ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "chargesStatus") &&
                                Boolean(getIn(formik.errors, "chargesStatus"))
                              }
                              helperText={
                                getIn(formik.touched, "chargesStatus") &&
                                getIn(formik.errors, "chargesStatus")
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              type="number"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Charges Amount"
                              id={`containerDetailsListField.${index}.chargesAmount`}
                              placeholder="Enter Charges Amount"
                              disabled={false}
                              name={`containerDetailsListField.${index}.chargesAmount`}
                              value={
                                formik.values.containerDetailsListField
                                  ? formik.values.containerDetailsListField[index]?.chargesAmount ||
                                    data?.chargesAmount ||
                                    ""
                                  : ""
                              }
                              onChange={handleValueChange}
                              error={
                                getIn(formik.touched, "chargesAmount") &&
                                Boolean(getIn(formik.errors, "chargesAmount"))
                              }
                              helperText={
                                getIn(formik.touched, "chargesAmount") &&
                                getIn(formik.errors, "chargesAmount")
                              }
                            />
                          </Box>
                        </Grid> */}
                            {formik.values.consignmentTypeName !== "Empty-Export" &&
                              terminalType !== 4 && (
                                <Grid item xs={12} md={4}>
                                  <Box>
                                    <TextField
                                      multiline
                                      rowsMax={5}
                                      size="small"
                                      fullWidth
                                      className="customTextField"
                                      variant="outlined"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      label="EIR Remarks"
                                      id={`containerDetailsListField.${index}.eirRemarks`}
                                      placeholder="Enter EIR Remarks"
                                      disabled={false}
                                      name={`containerDetailsListField.${index}.eirRemarks`}
                                      value={
                                        formik.values.containerDetailsListField
                                          ? formik.values.containerDetailsListField[index]
                                              ?.eirRemarks ||
                                            data?.eirRemarks ||
                                            ""
                                          : ""
                                      }
                                      onChange={handleValueChange}
                                      error={
                                        getIn(formik.touched, "eirRemarks") &&
                                        Boolean(getIn(formik.errors, "eirRemarks"))
                                      }
                                      helperText={
                                        getIn(formik.touched, "eirRemarks") &&
                                        getIn(formik.errors, "eirRemarks")
                                      }
                                    />
                                  </Box>
                                </Grid>
                              )}
                            {formik.values.consignmentTypeName !== "Empty-Export" &&
                              terminalType !== 4 && (
                                <Grid item xs={12} md={4}>
                                  <Box>
                                    <TextField
                                      multiline
                                      rowsMax={5}
                                      size="small"
                                      fullWidth
                                      className="customTextField"
                                      variant="outlined"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      label="Previous Remarks"
                                      id={`containerDetailsListField.${index}.previousRemarks`}
                                      placeholder="Enter Previous Remarks"
                                      disabled={false}
                                      name={`containerDetailsListField.${index}.previousRemarks`}
                                      value={
                                        formik.values.containerDetailsListField
                                          ? formik.values.containerDetailsListField[index]
                                              ?.previousRemarks ||
                                            data?.previousRemarks ||
                                            ""
                                          : ""
                                      }
                                      onChange={handleValueChange}
                                      error={
                                        getIn(formik.touched, "previousRemarks") &&
                                        Boolean(getIn(formik.errors, "previousRemarks"))
                                      }
                                      helperText={
                                        getIn(formik.touched, "previousRemarks") &&
                                        getIn(formik.errors, "previousRemarks")
                                      }
                                    />
                                  </Box>
                                </Grid>
                              )}
                          </>
                        )}

                        {containerList.length && formik.values.consignmentTypeName === "LCL-Empty" && (
                          <Grid item xs={12} md={3}>
                            <Box>
                              <CommonButton
                                cssClass="customDeleteBtn"
                                onClick={() => handleDeleteContainer(index)} // Optional: disable when only one container is left
                              >
                                {"Remove this container"}
                              </CommonButton>
                            </Box>
                          </Grid>
                        )}
                      </>
                    ))}
                  {/* Driver Details Section */}
                  <Grid item md={12} className={classes.sectionHeading}>
                    <Typography>Driver’s Details:</Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        required
                        size="small"
                        fullWidth
                        className="customTextField"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Driver Name"
                        name="driverName"
                        id="driverName"
                        placeholder="Enter Driver Name"
                        value={formik.values.driverName}
                        onChange={handleValueChange}
                        onPaste={(e: any) => {
                          if (/[^A-Za-z ]/.test(e.clipboardData.getData("text")))
                            e.preventDefault();
                        }}
                        onKeyDownCapture={(e: any) => {
                          if (/[^A-Za-z ]/.test(e.key)) e.preventDefault();
                        }}
                        error={formik.touched.driverName && Boolean(formik.errors.driverName)}
                        helperText={formik.touched.driverName && formik.errors.driverName}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box>
                      <InputMask
                        mask="+99-999-999-9999"
                        value={formik.values.driverMobileNumber}
                        disabled={false}
                        onChange={handleValueChange}
                      >
                        {() => (
                          <TextField
                            size="small"
                            fullWidth
                            required={terminalType !== 4}
                            className="customTextField"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Driver’s Mobile Number"
                            name="driverMobileNumber"
                            id="driverMobileNumber"
                            placeholder="+92-123-456-7890"
                            type="text"
                            error={
                              formik.touched.driverMobileNumber &&
                              Boolean(formik.errors.driverMobileNumber)
                            }
                            helperText={
                              formik.touched.driverMobileNumber && formik.errors.driverMobileNumber
                            }
                          />
                        )}
                      </InputMask>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        size="small"
                        fullWidth
                        required={terminalType !== 4}
                        className="customTextField"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Driver's CNIC"
                        name="driverCNIC"
                        id="driverCNIC"
                        placeholder="Enter Driver's CNIC"
                        disabled={false}
                        value={formik.values.driverCNIC}
                        onChange={handleValueChange}
                        onPaste={(e: any) => {
                          if (/[^A-Za-z0-9-,_ ]/.test(e.clipboardData.getData("text")))
                            e.preventDefault();
                        }}
                        onKeyDownCapture={(e: any) => {
                          if (/[^A-Za-z0-9-,_ ]/.test(e.key)) e.preventDefault();
                        }}
                        error={formik.touched.driverCNIC && Boolean(formik.errors.driverCNIC)}
                        helperText={formik.touched.driverCNIC && formik.errors.driverCNIC}
                      />
                    </Box>
                  </Grid>
                  {/* <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        size="small"
                        fullWidth
                        className="customTextField"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="NTN"
                        name="driverNTN"
                        id="driverNTN"
                        placeholder="Enter NTN"
                        disabled={false}
                        value={formik.values.driverNTN}
                        onChange={handleValueChange}
                        onPaste={(e: any) => {
                          if (/[^A-Za-z0-9- ]/.test(e.clipboardData.getData("text")))
                            e.preventDefault();
                        }}
                        onKeyDownCapture={(e: any) => {
                          if (/[^A-Za-z0-9- ]/.test(e.key)) e.preventDefault();
                        }}
                        error={formik.touched.driverNTN && Boolean(formik.errors.driverNTN)}
                        helperText={formik.touched.driverNTN && formik.errors.driverNTN}
                      />
                    </Box>
                  </Grid> */}
                  {/* importer */}
                  {/* <Grid item xs={12} md={6}>
                    <Box>
                      <CommonAutoCompleteField
                        cssClassName="customTextField"
                        label="Importer Name"
                        placeholder="Select Importer Name"
                        name="importerName"
                        optionsType={supplierTypeList.filter(
                          (option: any) => option.supplierType == "Importer"
                        )}
                        getOptionLabel={(option: any) => option.supplierName || ""}
                        renderOption={(option) => <span>{option.supplierName}</span>}
                        // required
                        value={
                          supplierTypeList.find(
                            (st: any) => st.supplierName === formik.values.importerName
                          ) || null
                        }
                        onChange={(option: any) => {
                          option && option !== ""
                            ? formik.setFieldValue("importerName", option.supplierName)
                            : "";
                        }}
                        error={formik.touched.importerName && Boolean(formik.errors.importerName)}
                        helperText={formik.touched.importerName && formik.errors.importerName}
                      />
                    </Box>
                  </Grid> */}
                  {/* <Grid item xs={12} md={6}>
                    <Box>
                      <InputMask
                        mask="+99-999-999-9999"
                        value={formik.values.importerPhoneNumber}
                        disabled={false}
                        onChange={handleValueChange}
                      >
                        {() => (
                          <TextField
                            size="small"
                            fullWidth
                            className="customTextField"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Importer Phone Number"
                            name="importerPhoneNumber"
                            id="importerPhoneNumber"
                            placeholder="+92-123-456-7890"
                            type="text"
                            error={
                              formik.touched.importerPhoneNumber &&
                              Boolean(formik.errors.importerPhoneNumber)
                            }
                            helperText={
                              formik.touched.importerPhoneNumber &&
                              formik.errors.importerPhoneNumber
                            }
                          />
                        )}
                      </InputMask>
                    </Box>
                  </Grid> */}
                  {/* exporter */}
                  {/* <Grid item xs={12} md={6}>
                    <Box>
                      <CommonAutoCompleteField
                        cssClassName="customTextField"
                        label="Exporter Name"
                        placeholder="Select Exporter Name"
                        name="exporterName"
                        optionsType={supplierTypeList.filter(
                          (option: any) => option.supplierType == "Exporter"
                        )}
                        getOptionLabel={(option: any) => option.supplierName || ""}
                        renderOption={(option) => <span>{option.supplierName}</span>}
                        // required
                        value={
                          supplierTypeList.find(
                            (st: any) => st.supplierName === formik.values.exporterName
                          ) || null
                        }
                        onChange={(option: any) => {
                          option && option !== ""
                            ? formik.setFieldValue("exporterName", option.supplierName)
                            : "";
                        }}
                        error={formik.touched.exporterName && Boolean(formik.errors.exporterName)}
                        helperText={formik.touched.exporterName && formik.errors.exporterName}
                      />
                    </Box>
                  </Grid> */}
                  {/* <Grid item xs={12} md={6}>
                    <Box>
                      <InputMask
                        mask="+99-999-999-9999"
                        value={formik.values.exporterPhoneNumber}
                        disabled={false}
                        onChange={handleValueChange}
                      >
                        {() => (
                          <TextField
                            size="small"
                            fullWidth
                            className="customTextField"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Exporter Phone Number"
                            name="exporterPhoneNumber"
                            id="exporterPhoneNumber"
                            placeholder="+92-123-456-7890"
                            type="text"
                            error={
                              formik.touched.exporterPhoneNumber &&
                              Boolean(formik.errors.exporterPhoneNumber)
                            }
                            helperText={
                              formik.touched.exporterPhoneNumber &&
                              formik.errors.exporterPhoneNumber
                            }
                          />
                        )}
                      </InputMask>
                    </Box>
                  </Grid> */}
                  {/* <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        size="small"
                        fullWidth
                        className="customTextField"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Resident"
                        name="driverResident"
                        id="driverResident"
                        placeholder="Enter Resident"
                        disabled={false}
                        value={formik.values.driverResident}
                        onChange={handleValueChange}
                        // onPaste={(e: any) => {
                        //   if (/[^A-Za-z ]/.test(e.clipboardData.getData("text")))
                        //     e.preventDefault();
                        // }}
                        // onKeyDownCapture={(e: any) => {
                        //   if (/[^A-Za-z ]/.test(e.key)) e.preventDefault();
                        // }}
                        error={
                          formik.touched.driverResident && Boolean(formik.errors.driverResident)
                        }
                        helperText={formik.touched.driverResident && formik.errors.driverResident}
                      />
                    </Box>
                  </Grid> */}
                  {/* Cargo Information Section */}
                  {/* <Grid item md={12} className={classes.sectionHeading}>
                    <Typography>Cargo Information: </Typography>
                  </Grid> */}
                  {/* <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        size="small"
                        fullWidth
                        className="customTextField"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Good’s Declaration Number (GD#)"
                        name="gdNo"
                        id="gdNo"
                        placeholder="Enter GD#"
                        disabled={false}
                        value={formik.values.gdNo}
                        onChange={handleValueChange}
                        // onPaste={(e: any) => {
                        //   if (/[^A-Za-z0-9 ]/.test(e.clipboardData.getData("text")))
                        //     e.preventDefault();
                        // }}
                        // onKeyDownCapture={(e: any) => {
                        //   if (/[^A-Za-z0-9 ]/.test(e.key)) e.preventDefault();
                        // }}
                        error={formik.touched.gdNo && Boolean(formik.errors.gdNo)}
                        helperText={formik.touched.gdNo && formik.errors.gdNo}
                      />
                    </Box>
                  </Grid> */}
                  {/* <Grid item xs={12} md={4}>
                    <CommonTextFieldDate
                      cssClassName={`${classes.dateTime} ${"customTextField"}`}
                      outerCss={true}
                      datePickerRef={gddatePickerRef}
                      label={"GD Date"}
                      name={"gdDate"}
                      value={formik.values.gdDate}
                      onChange={(e: any) => {
                        formik.setFieldValue("gdDate", e);
                        handleValueChange({ target: { value: e } });
                      }}
                      maxDate={moment().format("YYYY-MM-DD")}
                      // isReadOnly={updateCase}
                      enableTime={false}
                      error={formik.touched.gdDate && Boolean(formik.errors.gdDate)}
                      helperText={formik.touched.gdDate && formik.errors.gdDate}
                    />
                    {/* <Box>
                      <TextField
                        variant="outlined"
                        id="gdDate"
                        label="GD Date"
                        type="date"
                        InputProps={{
                          inputProps: { max: moment(new Date()).format("YYYY-MM-DD") || "" },
                        }}
                        className={`${classes.dateTime} ${"customTextField"}`}
                        onChange={(event: any) => {
                          formik.setFieldValue("gdDate", event.target.value);
                          handleValueChange({ target: { value: event.target.value } });
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Box> 
                  </Grid> */}
                  {/* <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        size="small"
                        fullWidth
                        className="customTextField"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Supplier Name"
                        name="supplierName"
                        id="supplierName"
                        placeholder="Enter Supplier Name"
                        disabled={false}
                        value={formik.values.supplierName}
                        onChange={handleValueChange}
                        onPaste={(e: any) => {
                          if (/[^A-Za-z ]/.test(e.clipboardData.getData("text")))
                            e.preventDefault();
                        }}
                        onKeyDownCapture={(e: any) => {
                          if (/[^A-Za-z ]/.test(e.key)) e.preventDefault();
                        }}
                        error={formik.touched.supplierName && Boolean(formik.errors.supplierName)}
                        helperText={formik.touched.supplierName && formik.errors.supplierName}
                      />
                    </Box>
                  </Grid> */}
                  {/* <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        size="small"
                        fullWidth
                        className="customTextField"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="WeBOC ID (IGM#)"
                        name="webBocId"
                        id="webBocId"
                        placeholder="Enter WeBOC ID (IGM#)"
                        disabled={false}
                        value={formik.values.webBocId}
                        onChange={handleValueChange}
                        error={formik.touched.webBocId && Boolean(formik.errors.webBocId)}
                        helperText={formik.touched.webBocId && formik.errors.webBocId}
                      />
                    </Box>
                  </Grid> */}
                  {/* Others Section */}
                  {terminalType !== 4 && (
                    <>
                      <Grid item md={12} className={classes.sectionHeading}>
                        <Typography>Others: </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Box>
                          <TextField
                            multiline
                            rows={2}
                            rowsMax={5}
                            size="small"
                            fullWidth
                            className="customTextField"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Remarks"
                            name="notes"
                            id="notes"
                            placeholder="Enter Remarks"
                            disabled={false}
                            value={formik.values.notes}
                            onChange={handleValueChange}
                            error={formik.touched.notes && Boolean(formik.errors.notes)}
                            helperText={formik.touched.notes && formik.errors.notes}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Box>
                          <TextField
                            multiline
                            rows={2}
                            rowsMax={5}
                            size="small"
                            fullWidth
                            className="customTextField"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Condition"
                            name="remarks"
                            id="remarks"
                            placeholder="Enter Condition"
                            disabled={false}
                            value={formik.values.remarks}
                            onChange={handleValueChange}
                            error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                            helperText={formik.touched.remarks && formik.errors.remarks}
                          />
                        </Box>
                      </Grid>
                    </>
                  )}
                  {/* Vehicle Details Section */}
                  {terminalType === 4 && (
                    <>
                      <Grid item md={12} className={classes.sectionHeading}>
                        <Typography>Vehicle Details:</Typography>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <CommonAutoCompleteField
                            cssClassName="customTextField"
                            required
                            error={
                              formik.touched.vehicleStatusId &&
                              Boolean(formik.errors.vehicleStatusId)
                            }
                            helperText={
                              formik.touched.vehicleStatusId && formik.errors.vehicleStatusId
                            }
                            label="Vehicle Status"
                            placeholder="Select Vehicle Status"
                            name="vehicleStatusId"
                            optionsType={vehiclestatusList}
                            getOptionLabel={(option) => option.name}
                            value={
                              vehiclestatusList.find(
                                (st: any) => st.id === formik.values.vehicleStatusId
                              ) || null
                            }
                            onChange={(option: any) => {
                              if (option && option.id !== 0) {
                                formik.setFieldValue("vehicleStatusId", option.id);
                                handleValueChange({ target: { value: option.id } });
                              }
                            }}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <CommonAutoCompleteField
                            cssClassName="customTextField"
                            error={
                              formik.touched.locationInTerminal &&
                              Boolean(formik.errors.locationInTerminal)
                            }
                            helperText={
                              formik.touched.locationInTerminal && formik.errors.locationInTerminal
                            }
                            required
                            label="Location at Terminal"
                            placeholder="Select Location at Terminal"
                            name="locationInTerminal"
                            optionsType={locationAtTerminal}
                            getOptionLabel={(option: any) => option.name || ""}
                            value={
                              locationAtTerminal.find(
                                (st: any) => st.id === formik.values.locationInTerminal
                              ) || null
                            }
                            onChange={(option: any) => {
                              if (option && option.id !== 0) {
                                formik.setFieldValue("locationInTerminal", option.id);
                                handleValueChange({ target: { value: option.id } });
                              }
                            }}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <TextField
                            className="customTextField"
                            size="small"
                            fullWidth
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Pass Number"
                            name="passNumber"
                            id="passNumber"
                            placeholder="Enter Pass Number"
                            disabled={false}
                            value={formik.values.passNumber}
                            onChange={handleValueChange}
                            error={formik.touched.passNumber && Boolean(formik.errors.passNumber)}
                            helperText={formik.touched.passNumber && formik.errors.passNumber}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={Boolean(formik.values.commercial)}
                                onChange={handleValueChange}
                                name="commercial"
                                color="primary"
                              />
                            }
                            label="Commercial"
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <TextField
                            className="customTextField"
                            size="small"
                            fullWidth
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Chassis Number"
                            name="vehicleChassisNumber"
                            id="vehicleChassisNumber"
                            placeholder="Enter Chassis Number"
                            disabled={false}
                            value={formik.values.vehicleChassisNumber}
                            onChange={handleValueChange}
                            error={
                              formik.touched.vehicleChassisNumber &&
                              Boolean(formik.errors.vehicleChassisNumber)
                            }
                            helperText={
                              formik.touched.vehicleChassisNumber &&
                              formik.errors.vehicleChassisNumber
                            }
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <TextField
                            size="small"
                            fullWidth
                            className="customTextField"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Vehicle Color"
                            name="vehicleColor"
                            id="vehicleColor"
                            placeholder="Enter Vehicle Color"
                            disabled={false}
                            value={formik.values.vehicleColor}
                            onChange={handleValueChange}
                            // onPaste={(e: any) => {
                            //   if (/[^A-Za-z ]/.test(e.clipboardData.getData("text")))
                            //     e.preventDefault();
                            // }}
                            // onKeyDownCapture={(e: any) => {
                            //   if (/[^A-Za-z ]/.test(e.key)) e.preventDefault();
                            // }}
                            error={
                              formik.touched.vehicleColor && Boolean(formik.errors.vehicleColor)
                            }
                            helperText={formik.touched.vehicleColor && formik.errors.vehicleColor}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <TextField
                            //
                            size="small"
                            fullWidth
                            className="customTextField"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Vehicle Brand"
                            name="vehicleBrand"
                            id="vehicleBrand"
                            placeholder="Enter Vehicle Brand"
                            disabled={false}
                            value={formik.values.vehicleBrand}
                            onChange={handleValueChange}
                            onPaste={(e: any) => {
                              if (/[^A-Za-z0-9- ]/.test(e.clipboardData.getData("text")))
                                e.preventDefault();
                            }}
                            onKeyDownCapture={(e: any) => {
                              if (/[^A-Za-z0-9- ]/.test(e.key)) e.preventDefault();
                            }}
                            error={
                              formik.touched.vehicleBrand && Boolean(formik.errors.vehicleBrand)
                            }
                            helperText={formik.touched.vehicleBrand && formik.errors.vehicleBrand}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <TextField
                            //
                            size="small"
                            fullWidth
                            className="customTextField"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Vehicle Model"
                            name="vehicleModel"
                            id="vehicleModel"
                            placeholder="Enter Vehicle Model"
                            disabled={false}
                            value={formik.values.vehicleModel}
                            onChange={handleValueChange}
                            // onPaste={(e: any) => {
                            //   if (/[^A-Za-z0-9 ]/.test(e.clipboardData.getData("text")))
                            //     e.preventDefault();
                            // }}
                            // onKeyDownCapture={(e: any) => {
                            //   if (/[^A-Za-z0-9 ]/.test(e.key)) e.preventDefault();
                            // }}
                            error={
                              formik.touched.vehicleModel && Boolean(formik.errors.vehicleModel)
                            }
                            helperText={formik.touched.vehicleModel && formik.errors.vehicleModel}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <InputMask
                            mask="9999"
                            value={formik.values.vehicleMake}
                            disabled={false}
                            onChange={handleValueChange}
                          >
                            {() => (
                              <TextField
                                size="small"
                                fullWidth
                                className="customTextField"
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                label="Vehicle Make/Year"
                                name="vehicleMake"
                                id="vehicleMake"
                                placeholder="2002"
                                type="text"
                                error={
                                  formik.touched.vehicleMake && Boolean(formik.errors.vehicleMake)
                                }
                                helperText={formik.touched.vehicleMake && formik.errors.vehicleMake}
                              />
                            )}
                          </InputMask>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <TextField
                            //
                            size="small"
                            fullWidth
                            className="customTextField"
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Agent Name"
                            name="agentName"
                            id="agentName"
                            placeholder="Enter Agent Name"
                            disabled={false}
                            value={formik.values.agentName}
                            onChange={handleValueChange}
                            onPaste={(e: any) => {
                              if (/[^A-Za-z ]/.test(e.clipboardData.getData("text")))
                                e.preventDefault();
                            }}
                            onKeyDownCapture={(e: any) => {
                              if (/[^A-Za-z ]/.test(e.key)) e.preventDefault();
                            }}
                            error={formik.touched.agentName && Boolean(formik.errors.agentName)}
                            helperText={formik.touched.agentName && formik.errors.agentName}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <InputMask
                            mask="+99-999-999-9999"
                            value={formik.values.agentMobileNumber}
                            disabled={false}
                            onChange={handleValueChange}
                          >
                            {() => (
                              <TextField
                                size="small"
                                fullWidth
                                className="customTextField"
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                label="Agent’s Mobile Number"
                                name="agentMobileNumber"
                                id="agentMobileNumber"
                                placeholder="+92-123-456-7890"
                                type="text"
                                error={
                                  formik.touched.agentMobileNumber &&
                                  Boolean(formik.errors.agentMobileNumber)
                                }
                                helperText={
                                  formik.touched.agentMobileNumber &&
                                  formik.errors.agentMobileNumber
                                }
                              />
                            )}
                          </InputMask>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CommonSelect
                          cssClassName="customTextField"
                          inputLabel="Vehicle Channel"
                          name="vehicleColorCode"
                          allValues={colorCodeListForGateIn}
                          value={formik.values.vehicleColorCode}
                          onChange={(event: SelectChangeEvent) => {
                            formik.setFieldValue("vehicleColorCode", event?.target?.value);
                            handleValueChange({ target: { value: event?.target?.value } });
                          }}
                          // {/* Commented out before UAT */}
                          // style={{
                          //   background: colorCodeListForGateIn.find(
                          //     (item) => item.value === formik.values.vehicleColorCode
                          //   )?.backgroundColor,
                          //   color: colorCodeListForGateIn.find(
                          //     (item) => item.value === formik.values.vehicleColorCode
                          //   )?.textColor,
                          //   fontWeight: 600,
                          // }}
                          // {/* Commented out before UAT */}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CommonSelect
                          cssClassName="customTextField"
                          inputLabel="WeBOC RMS Color Code"
                          name="vehicleCustomColorCode"
                          allValues={customColorCodeList}
                          value={formik.values.vehicleCustomColorCode}
                          onChange={(event: SelectChangeEvent) => {
                            formik.setFieldValue("vehicleCustomColorCode", event?.target?.value);
                            handleValueChange({ target: { value: event?.target?.value } });
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <CommonAutoCompleteField
                            cssClassName="customTextField"
                            error={formik.touched.yardId && Boolean(formik.errors.yardId)}
                            helperText={formik.touched.yardId && formik.errors.yardId}
                            label="Yard Name"
                            placeholder="Select Yard Name"
                            name="yardId"
                            optionsType={allYards}
                            getOptionLabel={(option: any) => option.name || ""}
                            value={
                              allYards.find((st: any) => st.id === formik.values.yardId) || null
                            }
                            onChange={(option: any) => {
                              if (option && option.id !== 0) {
                                // dispatch(getAllRowsByYardIdAction(option.id));
                                formik.setFieldValue("yardId", option.id);
                                handleValueChange({ target: { value: option.id } });
                              } else {
                                formik.setFieldValue("yardId", "");
                                formik.setFieldValue("yardRowId", "");
                                formik.setFieldValue("yardSlotId", "");
                                setAllRows([]);
                                setAllAvailableSlots([]);
                              }
                            }}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <CommonAutoCompleteField
                            cssClassName="customTextField"
                            error={formik.touched.yardRowId && Boolean(formik.errors.yardRowId)}
                            helperText={formik.touched.yardRowId && formik.errors.yardRowId}
                            label="Yard Row Number"
                            placeholder="Select Yard Row Number"
                            name="yardRowId"
                            optionsType={allRows}
                            getOptionLabel={(option: any) => option.rowName || ""}
                            value={
                              allRows.find((st: any) => st.yardRowId === formik.values.yardRowId) ||
                              null
                            }
                            onChange={(option: any) => {
                              if (option && option.id !== 0) {
                                // dispatch(getAllAvailableSlotsByRowIdAction(option.yardRowId));
                                formik.setFieldValue("yardRowId", option.yardRowId);
                                handleValueChange({ target: { value: option.yardRowId } });
                              } else {
                                formik.setFieldValue("yardRowId", "");
                                formik.setFieldValue("yardSlotId", "");
                                setAllAvailableSlots([]);
                              }
                            }}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box>
                          <CommonAutoCompleteField
                            cssClassName="customTextField"
                            error={formik.touched.yardSlotId && Boolean(formik.errors.yardSlotId)}
                            helperText={formik.touched.yardSlotId && formik.errors.yardSlotId}
                            label="Yard Row Slot"
                            placeholder="Select Yard Row Slot"
                            name="yardSlotId"
                            optionsType={allAvailableSlots}
                            getOptionLabel={(option: any) => option.columnOrder.toString() || ""}
                            value={
                              allAvailableSlots.find(
                                // on Add Page Show only Available Slots
                                (st: any) => st.id === formik.values.yardSlotId
                              ) || null
                            }
                            onChange={(option: any) => {
                              option && option.id !== 0
                                ? formik.setFieldValue("yardSlotId", option.id)
                                : formik.setFieldValue("yardSlotId", "");
                            }}
                          />
                        </Box>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </>
        </Grid>
      </form>
    </>
  );
}
